import React, { useRef, useState, useEffect } from 'react';
import {
  Grid,
  Menu,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
  Icon,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import routes from "trainerRoutes";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import RadioGroup from '@mui/material/RadioGroup';
import deleteIcon from "assets/images/icons8-delete-48.png";
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment-timezone';
import MKInput from 'components/MKInput';
import Breadcrumbs from "examples/Breadcrumbs";
import Checkbox from '@mui/material/Checkbox';
import add from "assets/images/icons8-add-67.png";
import CountryList from 'country-list-with-dial-code-and-flag';
import MKAvatar from "components/MKAvatar";
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import AWS from 'aws-sdk';
import ProfileCompletionScore from './ProfileCompletionScore';
import {
  GetCountries,
  GetState,
  GetCity,
  GetLanguages,
} from "react-country-state-city";
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              minHeight: '101vh',
              height: 'auto',
              p: 2,
              mx: { xs: 2, lg: 3 },
              mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

const Page = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [totalExp, setTotalExp] = useState('');
  const [trainingExp, setTrainingExp] = useState('');
  const [location, setLocation] = useState("");
  const [modeOfTraining, setModeOfTraining] = useState("");
  const [avgCommercialForLessThan4hrs, setAvgCommercialForLessThan4hrs] = useState("");
  const [avgCommercialFor4hrs, setAvgCommercialFor4hrs] = useState("");
  const [avgCommercialFor8hrs, setAvgCommercialFor8hrs] = useState("");
  const [timeZoneOpen, setTimeZoneOpen] = useState(false);
  const [mobNumber, setMobNumber] = useState("");
  const [emailID, setEmailId] = useState("");
  const [travelWithinCountry, setTravelWithinCountry] = useState('');
  const [travelOutsideCountry, setTravelOutsideCountry] = useState('');
  const [weekedTraining, setWeekedTraining] = useState('');
  const [individualTraining, setIndividualTraining] = useState('');
  const [recordTraining, setRecordTraining] = useState('');
  const [profileDescription, setProfileDescription] = useState("");
  const [currency, setCurrency] = useState('');
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
  const [profilePicture, setProfilePicture] = useState('');
  const [profilePicFile, setProfilePicFile] = useState('');
  const [resume, setResume] = useState('');
  const [s3BucketURL, setS3BucketURL] = useState('');
  const [gender, setGender] = useState("");
  const [secondaryNumber, setSecondaryNumber] = useState("");
  const [emergencyNumber, setEmergencyNumber] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [visa, setVisa] = useState("no");
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedSecContactCountry, setSelectedSecContactCountry] = useState('');
  const [secContactCountryCode, setSecContactCountryCode] = useState('');
  const [selectedEmgContactCountry, setSelectedEmgContactCountry] = useState('');
  const [emgContactCountryCode, setEmgContactCountryCode] = useState('');
  const [referenceContactCountryCode, setReferenceContactCountryCode] = useState('');
  const [differentlyAbled, setDifferentlyAbled] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [submitCompleted, setSubmitCompleted] = useState(false);

  const [certificateNeverExpires, setCertificateNeverExpires] = useState(false);
  const [salutation, setSalutation] = useState('');
  const [salutationDropdown, setSalutationDropdown] = useState('');
  const [referenceSalutationDropdown, setReferenceSalutationDropdown] = useState('');
  const [firstNameError, setFirstNameError] = useState(true);
  const [lastNameError, setLastNameError] = useState(true);
  const [locationError, setLocationError] = useState(true);
  const [secondaryNumberError, setSecondaryNumberError] = useState(true);
  const [emergencyNumberError, setEmergencyNumberError] = useState(true);
  const [passportNumberError, setPassportNumberError] = useState(true);
  const [avgCommercialForLessThan4hrsError, setAvgCommercialForLessThan4hrsError] = useState(true);
  const [avgCommercialFor4hrsError, setAvgCommercialFor4hrsError] = useState(true);
  const [avgCommercialFor8hrsError, setAvgCommercialFor8hrsError] = useState(true);
  const [isFieldProfileInteracted, setIsFieldProfileInteracted] = useState(false);
  const [isFieldProjectInteracted, setIsFieldProjectInteracted] = useState(false);
  const [totalNoOfTrainingsError, setTotalNoOfTrainingsError] = useState(true);
  const [commercialForLessThan4hrsError, setCommercialForLessThan4hrsError] = useState(true);
  const [commercialFor4hrsError, setCommercialFor4hrsError] = useState(true);
  const [commercialFor8hrsError, setCommercialFor8hrsError] = useState(true);
  const [emgSalutation, setEmgSalutation] = useState('');
  const [emgSalutationDropdown, setEmgSalutationDropdown] = useState('');
  const [emgFirstNameError, setEmgFirstNameError] = useState(true);
  const [emgLastNameError, setEmgLastNameError] = useState(true);
  const [secSalutation, setSecSalutation] = useState('');
  const [secSalutationDropdown, setSecSalutationDropdown] = useState('');
  const [secFirstNameError, setSecFirstNameError] = useState(true);
  const [secLastNameError, setSecLastNameError] = useState(true);

  const [currencies, setCurrencies] = useState(['']);
  const [skillsName, setSkillsName] = useState([]);
  const [clientName, setClientName] = useState([]);

  const [selectedSkills, setSelectedSkills] = useState([]);

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [currentStateList, setCurrentStateList] = useState([]);
  const [currentCityList, setCurrentCityList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [countryID, setCountryID] = useState(0);
  const [skillsText, setSkillsText] = useState('');
  const [allScoreList, setAllScoreList] = useState([]);
  const [profileCompletionScore, setProfileCompletionScore] = useState(0);
  const [loading, setLoading] = useState(false);
  const [generalInformationCompleted, setGeneralInformationCompleted] = useState(false);
  const [skillCompleted, setSkillCompleted] = useState(false);
  const [trainingExperienceCompleted, setTrainingExperienceCompleted] = useState(false);
  const [personalDetailsCompleted, setPersonalDetailsCompleted] = useState(false);

  useEffect(() => {
    GetCountries().then((result) => {
      setCountryList(result);
    });

    GetLanguages().then((result) => {
      setLanguageList(result);
    });
  }, []);

  const [bbdata, setbbdata] = useState([]);
  const [userId, setUserId] = useState("");
  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setbbdata(data);
          setMobNumber(data.mobile_number);
          setEmailId(data.email);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("token")]);
  console.log(bbdata);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setSkillsName(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [selectedSkills]);
  console.log("skillsName", skillsName);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/client-details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setClientName(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("clientName", clientName);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/get-profile-score/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setAllScoreList(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("allScoreList", allScoreList);

  const calculateProfileCompletionScore = () => {
    console.log("123123123123");
    const completedSections = [
      { key: 'GeneralInformation', completed: generalInfoValid },
      { key: 'Skills', completed: skillsValid },
      { key: 'TrainingExperience', completed: trainingExpInfoValid },
      { key: 'PersonalDetails', completed: personalInfoValid && (visa === 'no' || isVisaInfoFilled) },
      { key: 'WorkExperience', completed: jobProfiles.some(profile => Object.values(profile).some(value => value && value !== profile.trainerProfileID)) },
      {
        key: 'Certification', completed: certificationList.some(certification => (
          Object.entries(certification).some(([key, value]) => key !== 'trainerProfileID' && key !== 'certificateNeverExpires' && value)
        ) && certificationList.every(certification => certification.certificateNeverExpires === 'false'))
      },
      { key: 'Education', completed: educationList.some(edu => Object.values(edu).some(value => value && value !== edu.trainerProfileID)) },
      { key: 'Reference', completed: referenceList.some(reference => Object.values(reference).some(value => value && value !== reference.trainerProfileID)) },
      { key: 'SocialMedia', completed: Object.values(socialMediaUrls).some(value => value) },
      { key: 'WorkSample', completed: generalInfoValid && personalInfoValid && trainingExpInfoValid },
    ];

    const totalScore = completedSections.reduce((score, section) => {
      const sectionScore = allScoreList.find(item => item.sectionDescription === section.key)?.score || 0;
      return section.completed ? score + parseInt(sectionScore, 10) : score;
    }, 0);

    const maxScore = allScoreList.reduce((score, item) => score + parseInt(item.score, 10), 0);
    const completionPercentage = (totalScore / maxScore) * 100;

    const roundedCompletionPercentage = Math.round(completionPercentage);
    setProfileCompletionScore(roundedCompletionPercentage);
    console.log("completionPercentage", completionPercentage);
  };

  console.log("setProfileCompletionScore", profileCompletionScore);

  useEffect(() => {
    setJobProfiles((prevJobProfiles) =>
      prevJobProfiles.map((profile) => ({
        ...profile,
        trainerProfileID: userId,
      }))
    );

    setTrainingExperience((prevTrainingExperience) =>
      prevTrainingExperience.map((training) => ({
        ...training,
        trainerProfileID: userId,
      }))
    );

    setCertificationList((prevCertificate) =>
      prevCertificate.map((certificate) => ({
        ...certificate,
        trainerProfileID: userId,
      }))
    );

    setEducationList((prevEducation) =>
      prevEducation.map((education) => ({
        ...education,
        trainerProfileID: userId,
      }))
    );

    setReferenceList((prevReference) =>
      prevReference.map((reference) => ({
        ...reference,
        trainerProfileID: userId,
      }))
    );

    setPersonalDetails((prevPersonalDetails) => ({
      ...prevPersonalDetails,
      trainerProfileID: userId,
    }));

    setWorkSamples((prevWorkSamples) =>
      prevWorkSamples.map((work) => ({
        ...work,
        trainerProfileID: userId,
      }))
    );
  }, [userId]);

  const [personalDetails, setPersonalDetails] = useState({
    trainerProfileID: "",
    dob: "",
    gender: "",
    martialStatus: undefined,
    secSalutation: "",
    secFirstName: "",
    secLastName: "",
    secContactCountryCode: "",
    secondaryNumber: "",
    emgSalutation: "",
    emgFirstName: "",
    emgLastName: "",
    emgContactCountryCode: "",
    emergencyNumber: "",
    aadharNumber: "",
    panNumber: "",
    passportNumber: "",
    visa: "no",
    address: {
      addressLine1: "",
      addressLine2: "",
      country: "",
      city: "",
      state: "",
      pincode: "",
    },
    languages: [],
    differentlyAbled: "",
  });

  const [address, setAddress] = useState({
    addressLine1: '',
    addressLine2: '',
    country: '',
    city: '',
    state: '',
    pincode: '',
  });

  const [languages, setLanguages] = useState([
    { language: '', read: 'false', write: 'false', speak: 'false' },
  ]);

  const [visaInfo, setVisaInfo] = useState([
    {
      country: "",
      fromDate: "",
      toDate: "",
    },
  ]);

  const [jobProfiles, setJobProfiles] = useState([
    {
      trainerProfileID: '',
      companyName: '',
      designation: '',
      technology: '',
      employmentType: '',
      dateOfJoining: '',
      dateOfLeaving: '',
      jobProfile: '',
    },
  ]);

  const [trainingExperience, setTrainingExperience] = useState([
    {
      trainerProfileID: '',
      profileName: '',
      trainingTechnology: '',
      clientDelivered: '',
      trainingDuration: '',
      totalNoOfTrainings: '',
      dateOfLastTraining: '',
      totalTrainingExperience: '',
      deliveryMethod: '',
      demoLink: '',
      uploadedFeedbackName: '',
      uploadedTocName: '',
      projectTitle: '',
      projectDescription: '',
      selectedCommercialsCurrency: '',
      commercialsCurrency: '',
      forLessThan4hrs: '',
      for4hrs: '',
      for8hrs: '',
    },
  ]);

  const [educationList, setEducationList] = useState([
    {
      trainerProfileID: "",
      education: "",
      university: "",
      course: "",
      specialization: "",
      mark: "",
      modeOfLearning: "",
      fromYear: "",
      toYear: "",
    },
  ]);

  const [certificationList, setCertificationList] = useState([
    {
      trainerProfileID: "",
      technology: "",
      certificationName: "",
      certificationId: "",
      url: "",
      uploadedCertificateName: "",
      certificateNeverExpires: false,
      certificationFromYear: "",
      certificationToYear: "",
    },
  ]);

  const [certificates, setCertificates] = useState(new Array(certificationList.length).fill([]));

  const socialMediaPlatforms = [
    { label: "GitHub", name: "gitHubUrl" },
    { label: "LinkedIn", name: "linkedInUrl" },
    { label: "Facebook", name: "facebookUrl" },
    { label: "Twitter", name: "twitterUrl" },
    { label: "Instagram", name: "instagramUrl" },
    { label: "Youtube", name: "youtubeUrl" },
  ];

  const [socialMediaUrls, setSocialMediaUrls] = useState({
    facebookUrl: "",
    twitterUrl: "",
    linkedInUrl: "",
    instagramUrl: "",
    gitHubUrl: "",
    youtubeUrl: "",
  });

  const [workSamples, setWorkSamples] = useState([
    { trainerProfileID: "", title: "", description: "", workUrl: "", uploadedWorkSampleName: "" },
  ]);

  const [documents, setDocuments] = useState(new Array(workSamples.length).fill([]));

  const [timeZone, setTimeZone] = useState([
    {
      workingTimeZone: "",
    },
  ]);

  const [generalInfoValid, setGeneralInfoValid] = useState(false);
  const GeneralInfoAllFieldsFilled = () => {
    const allFieldsFilled =
      salutation &&
      firstName &&
      lastName &&
      totalExp !== '' &&
      trainingExp !== '' &&
      location &&
      modeOfTraining &&
      selectedCurrencyCountry &&
      currency &&
      avgCommercialForLessThan4hrs &&
      avgCommercialFor4hrs &&
      avgCommercialFor8hrs &&
      timeZone &&
      travelWithinCountry &&
      travelOutsideCountry &&
      weekedTraining &&
      individualTraining &&
      recordTraining &&
      profilePicture &&
      resume &&
      profileDescription;

    const noErrors = firstNameError && lastNameError && locationError && avgCommercialForLessThan4hrsError && avgCommercialFor4hrsError && avgCommercialFor8hrsError;

    const isProfileDescriptionValid = profileDescription.length >= 100 && profileDescription.length <= 1000;

    setGeneralInfoValid(allFieldsFilled && noErrors && isProfileDescriptionValid);
  };

  useEffect(() => {
    GeneralInfoAllFieldsFilled();
  }, [
    salutation,
    firstName,
    lastName,
    totalExp,
    trainingExp,
    location,
    modeOfTraining,
    selectedCurrencyCountry,
    currency,
    avgCommercialForLessThan4hrs,
    avgCommercialFor4hrs,
    avgCommercialFor8hrs,
    timeZone,
    mobNumber,
    emailID,
    travelWithinCountry,
    travelOutsideCountry,
    weekedTraining,
    individualTraining,
    profilePicture,
    recordTraining,
    resume,
    profileDescription,
    firstNameError,
    lastNameError,
    locationError,
  ]);

  const [personalInfoValid, setPersonalInfoValid] = useState(false);
  const PersonalInfoAllFieldsFilled = () => {
    const allFieldsFilled =
      gender !== '' &&
      personalDetails.emgFirstName &&
      personalDetails.emgLastName &&
      emgSalutation !== '' &&
      selectedEmgContactCountry &&
      emgContactCountryCode &&
      emergencyNumber !== '' &&
      address.addressLine1 &&
      address.addressLine2 &&
      address.country &&
      address.city &&
      address.state &&
      address.pincode &&
      differentlyAbled;

    const noErrors = secondaryNumberError && emergencyNumberError && passportNumberError && emgFirstNameError && emgLastNameError;

    setPersonalInfoValid(allFieldsFilled && noErrors);
  };

  console.log(personalInfoValid);

  useEffect(() => {
    PersonalInfoAllFieldsFilled();
  }, [
    gender,
    selectedSecContactCountry,
    secContactCountryCode,
    secondaryNumber,
    selectedEmgContactCountry,
    emgContactCountryCode,
    emergencyNumber,
    address.addressLine1,
    address.addressLine2,
    selectedCountry,
    address.city,
    address.state,
    address.pincode,
    differentlyAbled,
    secondaryNumberError,
    emergencyNumberError,
    passportNumberError,
  ]);

  const [skillsValid, setSkillsValid] = useState(false);
  const SkillsFieldFilled = () => {
    const allFieldsFilled = selectedSkills.length > 0;

    setSkillsValid(allFieldsFilled);
  };

  useEffect(() => {
    SkillsFieldFilled();
  }, [selectedSkills]);
  console.log("selectedSkills", selectedSkills);

  const [trainingExpInfoValid, setTrainingExpInfoValid] = useState(false);
  const TrainingExpInfoAllFieldsFilled = () => {
    const allFieldsFilled =
      trainingExperience[0].profileName &&
      trainingExperience[0].trainingTechnology &&
      trainingExperience[0].trainingDuration &&
      trainingExperience[0].clientDelivered &&
      trainingExperience[0].totalNoOfTrainings &&
      trainingExperience[0].dateOfLastTraining &&
      trainingExperience[0].totalTrainingExperience &&
      trainingExperience[0].deliveryMethod &&
      trainingExperience[0].selectedCommercialsCurrency &&
      trainingExperience[0].commercialsCurrency &&
      trainingExperience[0].forLessThan4hrs &&
      trainingExperience[0].for4hrs &&
      trainingExperience[0].for8hrs;

    const noErrors =
      totalNoOfTrainingsError &&
      commercialForLessThan4hrsError &&
      commercialFor4hrsError &&
      commercialFor8hrsError;

    setTrainingExpInfoValid(allFieldsFilled && noErrors);
  };

  useEffect(() => {
    TrainingExpInfoAllFieldsFilled();
  }, [
    trainingExperience,
    totalNoOfTrainingsError,
    commercialForLessThan4hrsError,
    commercialFor4hrsError,
    commercialFor8hrsError,
  ]);

  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    if (menuItem === 'GeneralInformation') {
      setCurrentStep(1);
    } else if (menuItem === 'Skills') {
      setCurrentStep(2);
    } else if (menuItem === 'TrainingExperience') {
      setCurrentStep(3);
    } else if (menuItem === 'PersonalDetails') {
      setCurrentStep(4);
    } else if (menuItem === 'WorkExperience') {
      setCurrentStep(5);
    } else if (menuItem === 'Certification') {
      setCurrentStep(6);
    } else if (menuItem === 'Reference') {
      setCurrentStep(7);
    } else if (menuItem === 'Education') {
      setCurrentStep(8);
    } else if (menuItem === 'SocialMedia') {
      setCurrentStep(9);
    } else if (menuItem === 'WorkSample') {
      setCurrentStep(10);
    }
  };

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_S3_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  });

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainerhub/${id}_${userName}`;
    setS3BucketURL(bucketURL);
  }, [])

  const [profilePictureError, setProfilePictureError] = useState(null);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [svgSelectedFile, setSvgSelectedFile] = useState(null);

  const handleProfilePictureChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png',];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setProfilePictureError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 300 * 1024) {
        setProfilePictureError("File size should be maximum 300kb.");
        return;
      }
      setProfilePictureError(null);

      const renamedFile = new File([selectedFile], `profile-picture.${fileExtension}`, { type: selectedFile.type });
      setProfilePicFile(renamedFile);

      const reader = new FileReader();
      reader.onload = (e) => {
        setProfilePicture(e.target.result);
        setAvatarBackgroundColor('transparent');
        convertImageToSvg(e.target.result, renamedFile);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  console.log("profilePicture", profilePicture);
  console.log("profilePicture", profilePicFile);

  const convertImageToSvg = (imageData, profilePicFile) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/png');

      const svgString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${img.width}" height="${img.height}">
                        <image xlink:href="${dataURL}" width="${img.width}" height="${img.height}" />
                      </svg>`;

      setSvgSelectedFile(svgString);
    };

    img.onerror = (error) => {
      console.error('Error loading image:', error);
    };

    img.src = imageData;
  };


  const [resumeError, setResumeError] = useState(null);

  const resumeFileInputRef = useRef(null);

  const handleUploadClick = () => {
    resumeFileInputRef.current.click();
  };

  const handleResumeUploadChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileExtension = selectedFile.name.split('.').pop();

    if (selectedFile) {
      const allowedFormats = ['pdf', 'docx'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setResumeError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setResumeError("File size should be maximum 5mb.");
        return;
      }
      setResumeError(null);
      const renamedFile = new File([selectedFile], `resume.${fileExtension}`, { type: selectedFile.type });
      setResume(renamedFile);
    }
  };

  console.log("resume", resume);

  const documentFileInputRef = useRef(null);

  const handleDocumentUploadClick = () => {
    documentFileInputRef.current.click();
  };

  const [workSampleError, setWorkSampleError] = useState(null);
  const handleDocumentUploadChange = (index) => (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'docx'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setWorkSampleError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setWorkSampleError("File size should be maximum 5mb.");
        return;
      }

      setWorkSampleError(null);

      const renamedFile = new File([selectedFile], `workSampleDocument_${index + 1}.${fileExtension}`, {
        type: selectedFile.type,
      });
      const updatedDocuments = [...documents];
      updatedDocuments[index] = [...updatedDocuments[index], renamedFile];
      setDocuments(updatedDocuments);

      const workSamplesList = [...workSamples];
      workSamplesList[index].uploadedWorkSampleName = renamedFile.name;
      setWorkSamples(workSamplesList);

    }
  };
  console.log("document", documents);

  const certificateFileInputRef = useRef(null);

  const handleCertificateUploadClick = () => {
    certificateFileInputRef.current.click();
  };

  const [certificateError, setCertificateError] = useState(null);

  const handleCertificateUploadChange = (index) => (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'docx'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setCertificateError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setCertificateError("File size should be maximum 5mb.");
        return;
      }

      setCertificateError(null);

      const renamedFile = new File([selectedFile], `certificate_${index + 1}.${fileExtension}`, {
        type: selectedFile.type,
      });

      const updatedCertificates = [...certificates];
      updatedCertificates[index] = [...updatedCertificates[index], renamedFile];
      setCertificates(updatedCertificates);

      const updatedCertificationList = [...certificationList];
      updatedCertificationList[index].uploadedCertificateName = renamedFile.name;
      setCertificationList(updatedCertificationList);
    }
  };

  console.log("certificate", certificates);

  const handleFirstNameChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
    const isValid = !regex.test(input);
    setFirstNameError(isValid);
  };
  console.log("firstname", firstName);

  const handleLastNameChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
    const isValid = !regex.test(input);
    setLastNameError(isValid);
  };
  console.log("lastname", lastName);

  const options = Array.from({ length: 16 }, (_, index) => index);

  const handleTotalExpChange = (event) => {
    const selectedValue = event.target.value;
    if (/^\d+$/.test(selectedValue) || selectedValue === '') {
      setTotalExp(selectedValue);
    }
  };

  console.log("totalExp", totalExp);

  const handleTrainingExpChange = (event) => {
    const selectedValue = event.target.value;
    if (/^\d+$/.test(selectedValue) || selectedValue === '') {
      setTrainingExp(selectedValue);
    }
  };

  console.log("trainingExp", trainingExp);


  const handlePreferredModeChange = (e) => {
    setModeOfTraining(e.target.value);
  };
  console.log("modeOfTraining", modeOfTraining);

  const handleAvgCommercialForLessThan4hrsChange = (e) => {
    const input = e.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setAvgCommercialForLessThan4hrsError(isValid);
  };
  console.log("avgCommercial", avgCommercialForLessThan4hrs);

  const handleAvgCommercialFor4hrsChange = (e) => {
    const input = e.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setAvgCommercialFor4hrsError(isValid);
  };
  console.log("avgCommercialFor4hrs", avgCommercialFor4hrs);

  const handleAvgCommercialFor8hrsChange = (e) => {
    const input = e.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setAvgCommercialFor8hrsError(isValid);
  };
  console.log("avgCommercialFor8hrs", avgCommercialFor8hrs);

  const handleCountryCurrencyChange = (event) => {
    const selectedISO = event.target.value;
    setSelectedCurrencyCountry(selectedISO);

    const currencyInfo = getAllInfoByISO(selectedISO);
    setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  };

  console.log("currency", currency);
  console.log("selectedCurrencyCountry", selectedCurrencyCountry);

  const timeZones = moment.tz.names();

  const handleTimeZoneChange = (newValue) => {
    const formattedTimeZones = newValue.join(', ');
    setTimeZone(formattedTimeZones);
    setTimeZoneOpen(false);
  };


  console.log("timeZone", timeZone);

  const handleProfileChange = (e) => {
    setProfileDescription(e.target.value);
  };
  console.log("profileDescription", profileDescription);

  const [ageValidationError, setAgeValidationError] = useState(false);
  const handleDOBChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const today = new Date();
    const age = today.getFullYear() - selectedDate.getFullYear();

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      dob: e.target.value,
    }));

    if (age < 18) {
      setAgeValidationError(true);
    } else {
      setAgeValidationError(false);
    }
  };


  const handleGenderChange = (e) => {
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      gender: e.target.value,
    }));
    setGender(e.target.value);
  };

  console.log(gender);

  const handleMartialStatusChange = (e) => {
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      martialStatus: e.target.value,
    }));
  };

  const handleAddressCountryChange = (event) => {
    const selectedCountryIndex = event.target.value;
    const selectedCountry = countryList[selectedCountryIndex];

    setAddress((prevAddress) => ({
      ...prevAddress,
      country: selectedCountry.name,
    }));

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      address: {
        ...prevDetails.address,
        country: selectedCountry.name,
      },
    }));

    setCountryID(selectedCountry.id);

    GetState(selectedCountry.id).then((result) => {
      setStateList(result);
    });
  };

  const handleStateChange = (event) => {
    const selectedStateIndex = event.target.value;
    const selectedState = stateList[selectedStateIndex];

    setAddress((prevAddress) => ({
      ...prevAddress,
      state: selectedState.name,
    }));

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      address: {
        ...prevDetails.address,
        state: selectedState.name,
      },
    }));

    GetCity(countryID, selectedState.id).then((result) => {
      setCityList(result);
    });
  };

  const handleCityChange = (event) => {
    const selectedCityIndex = event.target.value;
    const selectedCity = cityList[selectedCityIndex];

    setAddress((prevAddress) => ({
      ...prevAddress,
      city: selectedCity.name,
    }));

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      address: {
        ...prevDetails.address,
        city: selectedCity.name,
      },
    }));
  };


  const [currentLocationCountry, setCurrentLocationCountry] = useState('');
  const [currentLocationState, setCurrentLocationState] = useState('');
  const [currentCountryID, setCurrentCountryID] = useState('');

  const handleCurrentLocationCountry = (event) => {
    const selectedCountryIndex = event.target.value;

    if (countryList && countryList.length > selectedCountryIndex) {
      const selectedCountry = countryList[selectedCountryIndex];

      setCurrentLocationCountry(selectedCountry.name);

      setCurrentCountryID(selectedCountry.id);

      GetState(selectedCountry.id).then((result) => {
        setCurrentStateList(result);
      });
    }
  };

  const handleCurrentLocationState = (event) => {
    const selectedStateIndex = event.target.value;

    if (currentStateList && currentStateList.length > selectedStateIndex) {
      const selectedState = currentStateList[selectedStateIndex];

      setCurrentLocationState(selectedState.name);

      GetCity(currentCountryID, selectedState.id).then((result) => {
        setCurrentCityList(result);
      });
    }
  };

  const handleCurrentLocationCity = (event) => {
    const selectedCityIndex = event.target.value;
    const selectedCity = currentCityList[selectedCityIndex];

    setLocation(selectedCity.name);
  };


  const handleAddressChange = (event) => {
    const { name, value } = event.target;
    const alphabetsRegex = /^[A-Za-z]*$/;
    const numbersRegex = /^[0-9]*$/;

    if (name === 'city' && !alphabetsRegex.test(value)) return;
    if (name === 'district' && !alphabetsRegex.test(value)) return;
    if (name === 'state' && !alphabetsRegex.test(value)) return;
    if (name === 'pincode' && !numbersRegex.test(value)) return;

    setAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      address: {
        ...prevDetails.address,
        [name]: value,
      },
    }));
  };


  console.log("address", address);

  const [isNewLanguageAdded, setIsNewLanguageAdded] = useState(false);

  const handleAddLanguage = () => {
    setLanguages([...languages, { language: '', read: 'false', write: 'false', speak: 'false' }]);
    setIsNewLanguageAdded(true);
  };

  const handleDeleteLanguage = (index) => {
    const updatedlanguages = [...languages];
    updatedlanguages.splice(index, 1);
    setLanguages(updatedlanguages);
    if (index - 1 === 0 && updatedlanguages.length < 1) {
      setIsNewLanguageAdded(false);
    }
  };


  const handleLanguageChange = (index, field, value) => {
    setLanguages((prevLanguages) => {
      const updatedLanguages = [...prevLanguages];
      updatedLanguages[index][field] = field === 'language' ? value : String(value);
      return updatedLanguages;
    });

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      languages: [...languages],
    }));
  };

  console.log("language", languages);

  const handleSecContactCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedSecContactCountry(selectedCountry);
    const country = CountryList.getAll().find((c) => c.name === selectedCountry);
    if (country) {
      setSecContactCountryCode(country.dialCode);
    }
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      secContactCountryCode: country.dialCode,
    }));
  };

  const handleSecondaryNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9+-]+$/;
    const isValid = regex.test(input);
    setSecondaryNumberError(isValid);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      secondaryNumber: input,
    }));
  };

  const openSecSalutationDropdown = (event) => {
    setSecSalutationDropdown(event.currentTarget);
  };

  const closeSecSalutationDropdown = () => {
    setSecSalutationDropdown(null);
  };

  const handleSecSalutationSelect = (salutation) => {
    setSecSalutation(salutation);
    console.log('Selected Salutation:', emgSalutation);
    closeSecSalutationDropdown();
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      secSalutation: salutation,
    }));
  };

  const openEmgSalutationDropdown = (event) => {
    setEmgSalutationDropdown(event.currentTarget);
  };

  const closeEmgSalutationDropdown = () => {
    setEmgSalutationDropdown(null);
  };

  const handleEmgSalutationSelect = (salutation) => {
    setEmgSalutation(salutation);
    console.log('Selected Salutation:', emgSalutation);
    closeEmgSalutationDropdown();
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      emgSalutation: salutation,
    }));
  };

  const handleReferenceContactCountryChange = (index, field, value) => {
    const selectedCountry = value;

    const updatedReferenceList = [...referenceList];
    updatedReferenceList[index] = { ...updatedReferenceList[index], [field]: selectedCountry };
    setReferenceList(updatedReferenceList);

    const country = CountryList.getAll().find((c) => c.name === selectedCountry);
    if (country) {
      setReferenceContactCountryCode(country.dialCode);
    }
    updatedReferenceList[index] = { ...updatedReferenceList[index], 'referenceContactCountryCode': country.dialCode };
    setReferenceList(updatedReferenceList);
  };

  const handleEmgContactCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedEmgContactCountry(selectedCountry);
    const country = CountryList.getAll().find((c) => c.name === selectedCountry);
    if (country) {
      setEmgContactCountryCode(country.dialCode);
    }
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      emgContactCountryCode: country.dialCode,
    }));
  };

  const handleEmergencyNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9+-]+$/;
    const isValid = regex.test(input);
    setEmergencyNumberError(isValid);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      emergencyNumber: input,
    }));
  };

  const handleAadharNumberChange = (e) => {
    const input = e.target.value;

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      aadharNumber: input,
    }));
  };

  const handlePanNumberChange = (e) => {
    const input = e.target.value;
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      panNumber: input,
    }));
  };

  const handlePassportNumberChange = (e) => {
    const input = e.target.value;
    const regex = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
    const isValid = regex.test(input);
    setPassportNumberError(isValid);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      passportNumber: input,
    }));
  };

  const handleVisaChange = (e) => {
    setVisa(e.target.value);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      visa: e.target.value,
    }));
  };

  const [isNewTimeZoneAdded, setIsNewTimeZoneAdded] = useState(false);

  const handleAddTimeZone = () => {
    setTimeZone([
      ...timeZone,
      {
        workingTimeZone: "",
      },
    ]);
    setIsNewTimeZoneAdded(true);
  };

  const handleDeleteTimeZone = (index) => {
    const updatedtimeZone = [...timeZone];
    updatedtimeZone.splice(index, 1);
    setTimeZone(updatedtimeZone);
    if (index - 1 === 0 && updatedtimeZone.length < 1) {
      setIsNewTimeZoneAdded(false);
    }
  };

  const [isNewVisaInfoAdded, setIsNewVisaInfoAdded] = useState(false);

  const handleAddVisaInfo = () => {
    setVisaInfo([
      ...visaInfo,
      {
        country: "",
        fromDate: "",
        toDate: "",
      },
    ]);
    setIsNewVisaInfoAdded(true);
  };

  const handleDeleteVisaInfo = (index) => {
    const updatedvisaInfo = [...visaInfo];
    updatedvisaInfo.splice(index, 1);
    setVisaInfo(updatedvisaInfo);
    if (index - 1 === 0 && updatedvisaInfo.length < 1) {
      setIsNewVisaInfoAdded(false);
    }
  };

  console.log("visaInfo", visaInfo);

  const handleCountryChange = (index, value) => {
    const validAlphabetsRegex = /^[A-Za-z]+$/;
    if (validAlphabetsRegex.test(value) || value === "") {
      const updatedVisaInfo = [...visaInfo];
      updatedVisaInfo[index].country = value;
      setVisaInfo(updatedVisaInfo);

      setPersonalDetails((prevDetails) => ({
        ...prevDetails,
        visaInfo: [...visaInfo],
      }));
    }
  };

  const handleFromDateChange = (index, value) => {
    const updatedVisaInfo = [...visaInfo];
    updatedVisaInfo[index].fromDate = value;
    setVisaInfo(updatedVisaInfo);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      visaInfo: [...visaInfo],
    }));
  };

  const handleToDateChange = (index, value) => {
    const updatedVisaInfo = [...visaInfo];
    updatedVisaInfo[index].toDate = value;
    setVisaInfo(updatedVisaInfo);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      visaInfo: [...visaInfo],
    }));
  };

  const [isVisaInfoFilled, setIsVisaInfoFilled] = useState(false);
  const checkVisaInfoFilled = () => {
    const isFilled = visaInfo.every(info =>
      info.country !== '' && info.fromDate !== '' && info.toDate !== ''
    );
    setIsVisaInfoFilled(isFilled);
  };

  useEffect(() => {
    checkVisaInfoFilled();
  }, [visaInfo]);

  const handleDifferentlyAbledChange = (e) => {
    setDifferentlyAbled(e.target.value);

    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      differentlyAbled: e.target.value,
    }));
  };

  console.log("personalDetails", personalDetails);

  const [isNewJobProfileAdded, setIsNewJobProfileAdded] = useState(false);

  const handleAddJobProfile = () => {
    const emptyJobProfile = {
      trainerProfileID: userId,
      companyName: '',
      designation: '',
      technology: '',
      employmentType: '',
      dateOfJoining: '',
      dateOfLeaving: '',
      jobProfile: '',
    };

    setJobProfiles([...jobProfiles, emptyJobProfile]);
    setIsNewJobProfileAdded(true);
  };

  const handleDeleteJobProfile = (index) => {
    const updatedjobProfiles = [...jobProfiles];
    updatedjobProfiles.splice(index, 1);
    setJobProfiles(updatedjobProfiles);
    if (index - 1 === 0 && updatedjobProfiles.length < 1) {
      setIsNewJobProfileAdded(false);
    }
  };

  const handleJobProfileChange = (event, index, field, value) => {
    const typedSkill = event.target.value;
    console.log("value@@@@@@@@@@@@@", typedSkill);
    console.log("index@@@@@@@@@@@@@", index);
    if (field === 'technology' && typedSkill && !skillsName.includes(typedSkill)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setSkillsName([...skillsName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    if (field === 'companyName' && typedSkill && !skillsName.includes(typedSkill)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/client-details/?q=${typedSkill}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setClientName([...clientName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const updatedProfiles = [...jobProfiles];
    if (!updatedProfiles[index]) {
      updatedProfiles[index] = {};
    }
    updatedProfiles[index][field] = value;
    setJobProfiles(updatedProfiles);
  };

  console.log("jobProfiles", jobProfiles);

  const handleTrainingTechnologyChange = (event, index, selectedValues) => {
    console.log("selectedValues@@@@@@@@@@@@@", selectedValues);
    const typedSkill = event.target.value;
    console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
    if (typedSkill && !skillsName.includes(typedSkill)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setSkillsName([...skillsName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        trainingTechnology: selectedValues.join(', '),
      };
      return updatedExperiences;
    });
  };


  const handleClientDeliveredChange = (event, index, selectedValues) => {
    console.log("selectedValues@@@@@@@@@@@@@", selectedValues);
    const typedClient = event.target.value;
    console.log("typedClient@@@@@@@@@@@@@", typedClient);
    if (typedClient && !clientName.includes(typedClient)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/client-details/?q=${typedClient}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setClientName([...clientName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        clientDelivered: selectedValues.join(', '),
      };
      return updatedExperiences;
    });
  };

  const handleProfileNameChange = (event, index) => {

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        profileName: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleStandardTrainingDuration = (event, index) => {

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        trainingDuration: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleTotalNoOfTrainingsChange = (event, index) => {
    const input = event.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setTotalNoOfTrainingsError(isValid);

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        totalNoOfTrainings: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const today = new Date().toISOString().split('T')[0];

  const handleDateOfLastTrainingChange = (event, index) => {
    const selectedDate = event.target.value;
    const today = new Date().toISOString().split('T')[0];

    if (selectedDate <= today) {
      setTrainingExperience((prevExperiences) => {
        const updatedExperiences = [...prevExperiences];
        updatedExperiences[index] = {
          ...updatedExperiences[index],
          dateOfLastTraining: event.target.value,
        };
        return updatedExperiences;
      });
    }
  };

  const handleTotalTrainingExperienceChange = (event, index) => {
    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        totalTrainingExperience: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleDeliveryMethodChange = (event, index) => {
    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        deliveryMethod: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleDemoLinkChange = (event, index) => {
    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        demoLink: event.target.value,
      };
      return updatedExperiences;
    });
  };

  console.log("trainingExperience", trainingExperience);

  const [isNewConsultingAdded, setIsNewConsultingAdded] = useState(false);

  const handleTitleChange = (event, index) => {
    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        projectTitle: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleDescriptionChange = (event, index) => {
    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        projectDescription: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleForLessThan4hrsChange = (event, index) => {
    const input = event.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setCommercialForLessThan4hrsError(isValid);

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        forLessThan4hrs: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleFor4hrsChange = (event, index) => {
    const input = event.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setCommercialFor4hrsError(isValid);

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        for4hrs: event.target.value,
      };
      return updatedExperiences;
    });
  };

  const handleFor8hrsChange = (event, index) => {
    const input = event.target.value;
    const regex = /^[0-9]*$/;
    const isValid = regex.test(input);
    setCommercialFor8hrsError(isValid);
    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        for8hrs: event.target.value,
      };
      return updatedExperiences;
    });

  };


  const handleCommercialsCurrencyChange = (event, index) => {
    console.log("event", event)
    const selectedISO = event.target.value;
    const currencyInfo = getAllInfoByISO(selectedISO);

    const updatedCurrencies = [...currencies];
    updatedCurrencies[index] = `${currencyInfo.currency} (${currencyInfo.symbol})`;
    setCurrencies(updatedCurrencies);

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        selectedCommercialsCurrency: selectedISO,
      };
      return updatedExperiences;
    });

    setTrainingExperience((prevExperiences) => {
      const updatedExperiences = [...prevExperiences];
      updatedExperiences[index] = {
        ...updatedExperiences[index],
        commercialsCurrency: updatedCurrencies[index],
      };
      return updatedExperiences;
    });
  }

  const generateNewFieldSet = () => ({
    trainerProfileID: userId,
    profileName: '',
    trainingTechnology: '',
    clientDelivered: '',
    totalNoOfTrainings: '',
    dateOfLastTraining: '',
    totalTrainingExperience: '',
    deliveryMethod: '',
    demoLink: '',
    uploadedFeedbackName: '',
    uploadedTocName: '',
    projectTitle: '',
    projectDescription: '',
    selectedCommercialsCurrency: '',
    forLessThan4hrs: '',
    for4hrs: '',
    for8hrs: '',
  });


  const [fieldSets, setFieldSets] = useState([generateNewFieldSet()]);

  const [isNewTrainingExperienceAdded, setIsNewTrainingExperienceAdded] = useState(false);

  const [feedbacks, setFeedbacks] = useState(new Array(fieldSets.length).fill([]));
  const [tocs, setTocs] = useState(new Array(fieldSets.length).fill([]));

  const handleAddTrainingExperience = () => {
    setFieldSets((prevFieldSets) => [...prevFieldSets, generateNewFieldSet()]);
    setTrainingExperience((prevExperiences) => [...prevExperiences, generateNewFieldSet()]);
    setFeedbacks([...feedbacks, []]);
    setTocs([...tocs, []]);
    setIsNewTrainingExperienceAdded(true);
  };

  console.log("isNewTrainingExperienceAdded", isNewTrainingExperienceAdded);

  const handleDeleteTrainingExperience = (index) => {
    const updatedFieldSets = [...fieldSets];
    updatedFieldSets.splice(index, 1);

    const updatedTrainingExperience = [...trainingExperience];
    updatedTrainingExperience.splice(index, 1);

    setFieldSets(updatedFieldSets);
    setTrainingExperience(updatedTrainingExperience);

    const updatedFeedbacks = [...feedbacks];
    updatedFeedbacks.splice(index, 1);
    setFeedbacks(updatedFeedbacks);

    const updatedTocs = [...tocs];
    updatedTocs.splice(index, 1);
    setTocs(updatedTocs);

    if (updatedTrainingExperience.length === 0) {
      setIsNewTrainingExperienceAdded(false);
    }
  };

  const feedbackFileInputRef = useRef(null);
  const tocFileInputRef = useRef(null);

  const uploadTocToS3 = async (file) => {
    const s3 = new AWS.S3();
    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET,
      Key: `${s3BucketURL}/toc/${file.name}`,
      Body: file,
    };

    try {
      const result = await s3.upload(params).promise();
      console.log('File uploaded successfully:', result.Location);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };


  const handleTocUploadClick = () => {
    tocFileInputRef.current.click();
  };

  const [tocError, setTocError] = useState(null);

  const handleTocUploadChange = (index) => (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['pdf', 'docx', 'xlsx', 'xls'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setTocError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setTocError("File size should be maximum 5mb.");
        return;
      }
      setTocError(null);

      const renamedFile = new File([selectedFile], `toc_${index + 1}.${fileExtension}`, {
        type: selectedFile.type,
      });
      const updatedTocs = [...tocs];
      updatedTocs[index] = [...updatedTocs[index], renamedFile];
      setTocs(updatedTocs);
      setTrainingExperience((prevExperiences) => {
        const updatedExperiences = [...prevExperiences];
        updatedExperiences[index] = {
          ...updatedExperiences[index],
          uploadedTocName: renamedFile.name,
        };
        return updatedExperiences;
      });
    }
  };

  console.log("toc", tocs);

  const uploadFeedbackToS3 = async (file) => {
    const s3 = new AWS.S3();
    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET,
      Key: `${s3BucketURL}/feedback/${file.name}`,
      Body: file,
    };

    try {
      const result = await s3.upload(params).promise();
      console.log('File uploaded successfully:', result.Location);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const [feedbackError, setFeedbackError] = useState(null);

  const handleFeedbackUploadClick = () => {
    feedbackFileInputRef.current.click();
  };

  const handleFeedbackUploadChange = (index) => (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'docx'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setFeedbackError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 300 * 1024) {
        setFeedbackError("File size should be maximum 300kb.");
        return;
      }
      setFeedbackError(null);

      const renamedFile = new File([selectedFile], `feedback_${index + 1}.${fileExtension}`, {
        type: selectedFile.type,
      });
      const updatedFeedbacks = [...feedbacks];
      updatedFeedbacks[index] = [...updatedFeedbacks[index], renamedFile]; // Add to the correct index
      setFeedbacks(updatedFeedbacks);

      setTrainingExperience((prevExperiences) => {
        const updatedExperiences = [...prevExperiences];
        updatedExperiences[index] = {
          ...updatedExperiences[index],
          uploadedFeedbackName: renamedFile.name,
        };
        return updatedExperiences;
      });
    }
  };

  console.log("feedback", feedbacks);

  const [isNewEducationAdded, setIsNewEducationAdded] = useState(false);

  const handleAddEducation = () => {
    setEducationList([...educationList, { trainerProfileID: userId, education: "", university: "", course: "", specialization: "", courseTime: "", mark: "", modeOfLearning: "", fromYear: "", toYear: "" }]);
    setIsNewEducationAdded(true);
  };

  const handleDeleteEducation = (index) => {
    const updatededucationList = [...educationList];
    updatededucationList.splice(index, 1);
    setEducationList(updatededucationList);
    if (index - 1 === 0 && updatededucationList.length < 1) {
      setIsNewEducationAdded(false);
    }
  };

  const saveEducationData = () => {
    const educationData = educationList.map((education) => ({
      education: education.education,
      university: education.university,
      course: education.course,
      specialization: education.specialization,
      courseTime: education.courseTime,
      mark: education.mark,
      modeOfLearning: education.modeOfLearning,
      fromYear: education.fromYear,
      toYear: education.toYear,
    }));
  };

  const yearOptions = Array.from({ length: 74 }, (_, idx) => new Date().getFullYear() - idx);

  const handleEducationChange = (index, field, value) => {
    const updatedEducationList = [...educationList];
    updatedEducationList[index] = { ...updatedEducationList[index], [field]: value };
    setEducationList(updatedEducationList);
  };

  console.log("educationList", educationList);

  const handleCertificateExpiryToggle = () => {
    setCertificateNeverExpires((prevValue) => !prevValue);
  };

  const [isNewCertificationAdded, setIsNewCertificationAdded] = useState(false);

  const handleAddCertification = () => {
    setCertificationList([
      ...certificationList,
      {
        trainerProfileID: userId,
        technology: "",
        certificationName: "",
        certificationId: "",
        url: "",
        uploadedCertificateName: "",
        certificateNeverExpires: false,
        certificationFromYear: "",
        certificationToYear: "",
      },
    ]);
    setCertificates([...certificates, []]);
    setIsNewCertificationAdded(true);
  };

  const handleDeleteCertification = (index) => {
    const updatedCertifications = [...certificationList];
    updatedCertifications.splice(index, 1);
    setCertificationList(updatedCertifications);
    console.log("index", index);
    console.log(updatedCertifications.length);

    const updatedCertificates = [...certificates];
    updatedCertificates.splice(index, 1);
    setCertificates(updatedCertificates);

    if (index - 1 === 0 && updatedCertifications.length < 1) {
      setIsNewCertificationAdded(false);
    }
  };

  const saveCertificationData = () => {
    const certificationData = certificationList.map((certification) => ({
      certificationName: certification.certificationName,
      certificationId: certification.certificationId,
      technology: certification.technology,
      url: certification.url,
      certificateNeverExpires: certification.certificateNeverExpires,
      certificationFromYear: certification.certificationFromYear,
      certificationToYear: certification.certificationToYear,
    }));
  };

  const handleCertificationChange = (index, field, value) => {
    console.log("value@@@@@@@@@@@@@", value);
    console.log("index@@@@@@@@@@@@@", index);
    if (field === 'technology' && value && !skillsName.includes(value)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setSkillsName([...skillsName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const updatedCertificationList = [...certificationList];
    if (field === 'certificateNeverExpires') {
      updatedCertificationList[index] = {
        ...updatedCertificationList[index],
        [field]: value ? 'true' : 'false', // Convert boolean to string only for this field
      };
      if (value) {
        updatedCertificationList[index].certificationFromYear = '';
        updatedCertificationList[index].certificationToYear = '';
      }
    } else {
      updatedCertificationList[index] = {
        ...updatedCertificationList[index],
        [field]: value,
      };
      updatedCertificationList[index].certificateNeverExpires = 'false';
    }
    setCertificationList(updatedCertificationList);
  };


  console.log("certificationList", certificationList);

  const handleSocialMediaUrlChange = (name, value) => {
    setSocialMediaUrls((prevUrls) => ({
      ...prevUrls,
      [name]: value,
    }));
  };

  console.log("socialMediaUrls", socialMediaUrls);

  const [isNewWorkSampleAdded, setIsNewWorkSampleAdded] = useState(false);

  const handleAddWorkSample = () => {
    setWorkSamples([...workSamples, { trainerProfileID: userId, title: "", description: "", workUrl: "", uploadedWorkSampleName: "" }]);
    setDocuments([...documents, []]);
    setIsNewWorkSampleAdded(true);
  };

  const handleDeleteWorkSample = (index) => {
    const updatedWorkSamples = [...workSamples];
    updatedWorkSamples.splice(index, 1);
    setWorkSamples(updatedWorkSamples);

    const updatedDocuments = [...documents];
    updatedDocuments.splice(index, 1);
    setDocuments(updatedDocuments);

    if (index - 1 === 0 && updatedWorkSamples.length < 1) {
      setIsNewWorkSampleAdded(false);
    }
  };

  const handleWorkSampleChange = (index, field, value) => {
    const updatedWorkSamples = [...workSamples];
    updatedWorkSamples[index] = {
      ...updatedWorkSamples[index],
      [field]: value,
    };
    setWorkSamples(updatedWorkSamples);
  };

  console.log("workSamples", workSamples);

  const [referenceList, setReferenceList] = useState([
    {
      trainerProfileID: "",
      referredBySalutation: "",
      referredByFirstName: "",
      referredByLastName: "",
      referenceContactCountry: "",
      referenceContactCountryCode: "",
      referredByMobileNumber: "",
      referredByEmailID: "",
    },
  ]);

  const [isNewReferenceAdded, setIsNewReferenceAdded] = useState(false);

  const handleAddReference = () => {
    setReferenceList([...referenceList, { trainerProfileID: userId, referredBySalutation: "", referredByFirstName: "", referredByLastName: "", referenceContactCountry: "", referenceContactCountryCode: "", referredByMobileNumber: "", referredByEmailID: "" }]);
    setIsNewReferenceAdded(true);
  };

  const handleDeleteReference = (index) => {
    const updatedReferenceList = [...referenceList];
    updatedReferenceList.splice(index, 1);
    setReferenceList(updatedReferenceList);
    if (index - 1 === 0 && updatedReferenceList.length < 1) {
      setIsNewReferenceAdded(false);
    }
  };

  const isNumeric = (value) => /^\d+$/.test(value);

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidAlphabet = (input) => /^[A-Za-z]+$/.test(input);

  const handleReferenceChange = (index, field, value) => {
    const updatedReferenceList = [...referenceList];
    updatedReferenceList[index] = { ...updatedReferenceList[index], [field]: value };
    setReferenceList(updatedReferenceList);
  };

  console.log("referenceList", referenceList);

  const handleTravelWithinCountryChange = (e) => {
    setTravelWithinCountry(e.target.value);
  };

  const handleTravelOutsideCountryChange = (e) => {
    setTravelOutsideCountry(e.target.value);
  };

  const handleWeekedTrainingChange = (e) => {
    setWeekedTraining(e.target.value);
  };

  const handleIndividualTrainingChange = (e) => {
    setIndividualTraining(e.target.value);
  };

  const handleRecordTrainingChange = (e) => {
    setRecordTraining(e.target.value);
  };

  const openSalutationDropdown = (event) => {
    setSalutationDropdown(event.currentTarget);
  };

  const closeSalutationDropdown = (event) => {
    if (event && salutationDropdown && salutationDropdown.contains(event.relatedTarget)) {
      return; // Clicked inside the menu, do not close
    }
    setSalutationDropdown(null);
  };

  const handleSalutationSelect = (salutation) => {
    setSalutation(salutation);
    console.log('Selected Salutation:', salutation);
    closeSalutationDropdown();
  };

  const openReferenceSalutationDropdown = (event) => {
    setReferenceSalutationDropdown(event.currentTarget);
  };

  const closeReferenceSalutationDropdown = () => {
    setReferenceSalutationDropdown(null);
  };

  const handleReferenceSalutationSelect = (salutation) => {
    handleReferenceChange(referenceList.length - 1, "referredBySalutation", salutation);
    closeReferenceSalutationDropdown();
  };

  const handleSkillClick = (skill) => {
    setSelectedSkills((prevSelectedSkills) => [...prevSelectedSkills, skill]);
  };

  const handleSkillsTextChange = (event) => {
    const typedSkill = event.target.value;
    console.log("typedSkill", typedSkill);
    setSkillsText(typedSkill);
    if (typedSkill && !skillsName.includes(typedSkill)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setSkillsName([...skillsName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  console.log("skillsText", skillsText);

  const onSubmitClick = async (e) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        workSample: workSamples,
        user_id: userId,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log(JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-worksample-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      if (response.ok && documents) {
        console.log("documents111111111111", documents);
        const formData = new FormData();

        const flattenedDocuments = documents.flat();

        for (let i = 0; i < flattenedDocuments.length; i++) {
          const document = flattenedDocuments[i];
          formData.append('files', document);

          // Log information about each appended file
          console.log(`Appended file ${i + 1}:`, {
            name: document.name,
            size: document.size,
            type: document.type,
          });
        }

        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/workSample/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Work Sample Document uploaded successfully");
      }
      // calculateProfileCompletionScore();
      setSubmitCompleted(true);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const onSendOTPClick = (e) => {
    const data = {
      mobile_number: mobNumber,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/send-otp/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setOtpSent(true);
        }
        return response.json(); // Parse the response JSON
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo");
      });
  };

  const handleOtpSubmit = () => {
    const data = {
      mobile_number: mobNumber,
      otp: otpValue,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/verify-otp/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setOtpSent(false);
        }
        return response.json(); // Parse the response JSON
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo");
      });
  };

  const DialogClose = () => {
    setOtpSent(false);
  };

  const DialogProfileClose = () => {
    // setSubmitCompleted(false);
    window.location.href = '/app/trainerdashboard';
  };

  const handleGeneralInformationNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        user_id: userId,
        salutation: salutation,
        firstName: firstName,
        lastName: lastName,
        profilePictureName: svgSelectedFile,
        uploadedResumeName: resume.name,
        S3BucketURL: s3BucketURL,
        totalExperience: totalExp,
        trainingExp: trainingExp,
        mobileNumber: mobNumber,
        email: emailID,
        currentLocationCountry: currentLocationCountry,
        currentLocationState: currentLocationState,
        location: location,
        profile: profileDescription,
        travelWithInYourCountry: travelWithinCountry,
        travelOutSideCountry: travelOutsideCountry,
        recordTraining: recordTraining,
        trainingMode: modeOfTraining,
        currencyCountry: selectedCurrencyCountry,
        currency: currency,
        avgCommercialForLessthan4hrs: avgCommercialForLessThan4hrs,
        avgCommercialFor4hrs: avgCommercialFor4hrs,
        avgCommercialFor8hrs: avgCommercialFor8hrs,
        workingTimeZone: timeZone,
        weekendTraining: weekedTraining,
        individualTraining: individualTraining,
        premiumStatus: "no",
        status: "Active",
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }

      if (response.ok && profilePicFile) {
        const formData = new FormData();
        formData.append('files', profilePicFile);
        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/profile-picture/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Profile pic uploaded successfully");
      }
      if (response.ok && resume) {
        console.log("resume111111", resume);
        const formData = new FormData();
        formData.append('files', resume);
        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/resume/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Resume uploaded successfully");
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setGeneralInformationCompleted(true);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleSkillsNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        skills: skillsText,
        profileCompleteScore: profileCompletionScore,
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-skills/${userId}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
      setSkillCompleted(true);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleTrainingExperienceNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        trainingExperience: trainingExperience,
        userId: userId,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-trainingexperience-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }

      if (response.ok && feedbacks) {
        console.log("feedbacks111111", feedbacks);
        const formData = new FormData();

        const flattenedFeedback = feedbacks.flat();

        for (let i = 0; i < flattenedFeedback.length; i++) {
          const feedback = flattenedFeedback[i];
          formData.append('files', feedback);

          console.log(`Appended file ${i + 1}:`, {
            name: feedback.name,
            size: feedback.size,
            type: feedback.type,
          });
        }

        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/feedback/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Feedback uploaded successfully");
      }

      if (response.ok && tocs) {
        console.log("tocs111111", tocs);
        const formData = new FormData();

        const flattenedToc = tocs.flat();

        for (let i = 0; i < flattenedToc.length; i++) {
          const toc = flattenedToc[i];
          formData.append('files', toc);

          console.log(`Appended file ${i + 1}:`, {
            name: toc.name,
            size: toc.size,
            type: toc.type,
          });
        }

        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/toc/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Toc uploaded successfully");
      }

      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
      setTrainingExperienceCompleted(true);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleWorkExperienceSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleWorkExperienceNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        workExperience: jobProfiles,
        userId: userId,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-workexperience-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleCertificateSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleCertificateNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        certifications: certificationList,
        userId: userId,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-certificate-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }

      if (response.ok && certificates) {
        console.log("certificates111111111111", certificates);
        const formData = new FormData();

        const flattenedCertificates = certificates.flat();

        for (let i = 0; i < flattenedCertificates.length; i++) {
          const certificate = flattenedCertificates[i];
          formData.append('files', certificate);

          // Log information about each appended file
          console.log(`Appended file ${i + 1}:`, {
            name: certificate.name,
            size: certificate.size,
            type: certificate.type,
          });
        }

        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/certificate/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Certificate uploaded successfully");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleEducationSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleEducationNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        educationDetails: educationList,
        userId: userId,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-educationdetail-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handlePersonalDetailsNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        trainerProfileID: userId,
        dob: personalDetails.dob,
        gender: personalDetails.gender,
        martialStatus: personalDetails.martialStatus,
        secSalutation: personalDetails.secSalutation,
        secFirstName: personalDetails.secFirstName,
        secLastName: personalDetails.secLastName,
        secContactCountryCode: personalDetails.secContactCountryCode,
        secondaryNumber: personalDetails.secondaryNumber,
        emgSalutation: personalDetails.emgSalutation,
        emgFirstName: personalDetails.emgFirstName,
        emgLastName: personalDetails.emgLastName,
        emgContactCountryCode: personalDetails.emgContactCountryCode,
        emergencyNumber: personalDetails.emergencyNumber,
        aadharNumber: personalDetails.aadharNumber,
        panNumber: personalDetails.panNumber,
        passportNumber: personalDetails.passportNumber,
        visa: personalDetails.visa,
        visaInfo: visaInfo,
        address: personalDetails.address,
        languages: personalDetails.languages,
        differentlyAbled: personalDetails.differentlyAbled,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-personaldetails-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
      setPersonalDetailsCompleted(true);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleSocialMediaSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleSocialMediaNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        socialMedia: socialMediaUrls,
        profileCompletionScore: profileCompletionScore,
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-social/${userId}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleReferenceSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleReferenceNextClick = async (menuItem) => {
    setLoading(true);
    calculateProfileCompletionScore();
    try {
      const data = {
        referredby: referenceList,
        userId: userId,
        profileCompletionScore: profileCompletionScore,
        eventTrigger: "Application"
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofile-referredby-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      // calculateProfileCompletionScore();
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const [currentStep, setCurrentStep] = useState(1);

  const handleNextClick = (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleBackClick = (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const sidebarStyles = {
    width: '250px',
    padding: '20px',
    color: 'white',
    borderRadius: '15px',
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={routes}
          sticky
        />
        <Card
          sx={{
            minHeight: '101vh',
            height: 'auto',
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Container>
            <Grid container>
              <Grid item xs={3} style={{ marginTop: "140px" }}>
                <div>
                  <Dialog
                    open={otpSent}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification! Please enter the OTP you have received
                    </DialogTitle>
                    <DialogContent>
                      <div>
                        <InputLabel>Enter OTP</InputLabel>
                        <TextField
                          variant="outlined"
                          value={otpValue}
                          onChange={(e) => setOtpValue(e.target.value)}
                        />
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleOtpSubmit} color="primary" autoFocus>
                        Submit OTP
                      </Button>
                      <Button onClick={DialogClose} color="primary">
                        Cancel
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Congratulations!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your profile is now officially live. Let the world discover the amazing you!
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Grid item xs={9}>
                    <div style={sidebarStyles}>
                      <MenuItem
                        onClick={() => handleMenuItemClick('GeneralInformation')}
                        style={activeMenuItem === 'GeneralInformation' || currentStep === 1 ? { fontWeight: 'bold' } : {}}
                      >
                        General Information
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('Skills')}
                        style={activeMenuItem === 'Skills' || currentStep === 2 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false}
                      >
                        Skills
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('TrainingExperience')}
                        style={activeMenuItem === 'TrainingExperience' || currentStep === 3 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false}
                      >
                        Training Experience
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('PersonalDetails')}
                        style={activeMenuItem === 'PersonalDetails' || currentStep === 4 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || trainingExperienceCompleted === false}
                      >
                        Personal Details
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('WorkExperience')}
                        style={activeMenuItem === 'WorkExperience' || currentStep === 5 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || personalDetailsCompleted === false || trainingExperienceCompleted === false}
                      >
                        Work Experience
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('Certification')}
                        style={activeMenuItem === 'Certification' || currentStep === 6 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || personalDetailsCompleted === false || trainingExperienceCompleted === false}
                      >
                        Certification
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('Reference')}
                        style={activeMenuItem === 'Reference' || currentStep === 7 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || personalDetailsCompleted === false || trainingExperienceCompleted === false}
                      >
                        Reference
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('Education')}
                        style={activeMenuItem === 'Education' || currentStep === 8 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || personalDetailsCompleted === false || trainingExperienceCompleted === false}
                      >
                        Education
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('SocialMedia')}
                        style={activeMenuItem === 'SocialMedia' || currentStep === 9 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || personalDetailsCompleted === false || trainingExperienceCompleted === false}
                      >
                        Social Media
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('WorkSample')}
                        style={activeMenuItem === 'WorkSample' || currentStep === 10 ? { fontWeight: 'bold' } : {}}
                        disabled={generalInformationCompleted === false || skillCompleted === false || personalDetailsCompleted === false || trainingExperienceCompleted === false}
                      >
                        Work Sample
                      </MenuItem>
                      <MenuItem>
                        <ProfileCompletionScore profileCompletionScore={profileCompletionScore} />
                      </MenuItem>
                    </div>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={9} style={{ marginTop: "160px" }}>
                {currentStep === 1 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>General Information</Typography>
                    <div>
                      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                        <div>
                          <MKAvatar
                            src={profilePicture}
                            alt="Profile Picture"
                            size="xl"
                            style={{ backgroundColor: avatarBackgroundColor }}
                          />
                        </div>
                        <div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleProfilePictureChange}
                            style={{ display: 'none' }}
                            id="profile-picture-input"
                          />
                          <label htmlFor="profile-picture-input">
                            <MKButton variant="gradient" color="info" component="span" size="small">
                              Upload Profile Picture&nbsp;&nbsp;<Icon>cloud_upload</Icon>
                            </MKButton>
                          </label>
                        </div>
                      </div>
                      {profilePictureError && (
                        <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                          {profilePictureError}
                        </MKTypography>
                      )}
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <MKButton variant="gradient" color="info" onClick={openSalutationDropdown}>
                            {salutation || 'Salutation *'} <Icon>expand_more</Icon>
                          </MKButton>
                          <Menu anchorEl={salutationDropdown} open={Boolean(salutationDropdown)} onClose={closeSalutationDropdown} onBlur={(event) => closeSalutationDropdown(event)}>
                            <MenuItem onClick={() => handleSalutationSelect('Mr.')}>Mr.</MenuItem>
                            <MenuItem onClick={() => handleSalutationSelect('Mrs.')}>Mrs.</MenuItem>
                            <MenuItem onClick={() => handleSalutationSelect('Miss.')}>Miss.</MenuItem>
                            <MenuItem onClick={() => handleSalutationSelect('Ms.')}>Ms.</MenuItem>
                          </Menu>
                        </div>
                        <div>
                          {/* <InputLabel style={{ marginBottom: "10px" }}>First Name</InputLabel> */}
                          <TextField
                            label="First Name *"
                            variant="outlined"
                            style={{ width: "250px", borderColor: firstNameError ? 'red' : undefined }}
                            fullWidth
                            value={firstName}
                            onChange={(e) => {
                              setFirstName(e.target.value);
                              handleFirstNameChange(e, setFirstNameError);
                            }}
                            error={!firstNameError}
                          />
                        </div>
                        <div>
                          <TextField
                            label="Last Name *"
                            variant="outlined"
                            style={{ width: "250px", borderColor: lastNameError ? 'red' : undefined }}
                            fullWidth
                            value={lastName}
                            onChange={(e) => {
                              setLastName(e.target.value);
                              handleLastNameChange(e, setLastNameError);
                            }}
                            error={!lastNameError}
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          {/* <InputLabel>Mobile Number</InputLabel> */}
                          <TextField
                            label="Mobile Number *"
                            variant="outlined"
                            style={{ width: "250px" }}
                            // onChange={handleMobNumberChange}
                            value={mobNumber}
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                        </div>
                        <div>
                          {/* <InputLabel>Mobile Number</InputLabel> */}
                          <TextField
                            label="Email Id *"
                            variant="outlined"
                            style={{ width: "250px" }}
                            // onChange={handleMobNumberChange}
                            value={emailID}
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Total Experience (in months)"
                            variant="outlined"
                            style={{ width: '250px' }}
                            fullWidth
                            onChange={handleTotalExpChange}
                            value={totalExp}
                            InputProps={{ inputProps: { min: 0 } }}
                            type="number"
                            required
                          />
                        </div>
                        <div>
                          <TextField
                            label="Training Experience (in months)"
                            variant="outlined"
                            style={{ width: '250px' }}
                            fullWidth
                            onChange={handleTrainingExpChange}
                            value={trainingExp}
                            InputProps={{ inputProps: { min: 0 } }}
                            type="number"
                            required
                          />
                        </div>
                        <div>
                          <FormControl variant="outlined" style={{ width: '250px' }}>
                            <InputLabel id="preferred-mode-label">Preferred Mode Of Training *</InputLabel>
                            <Select
                              labelId="preferred-mode-label"
                              label="Preferred Mode Of Training"
                              fullWidth
                              onChange={handlePreferredModeChange}
                              value={modeOfTraining}
                              style={{ minHeight: '44px' }}
                            >
                              <MenuItem value="Online">Online</MenuItem>
                              <MenuItem value="Classroom">Classroom</MenuItem>
                              <MenuItem value="Online,Classroom">Both</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div>
                        <Autocomplete
                          multiple
                          id="timeZone-autocomplete"
                          options={timeZones}
                          freeSolo
                          renderTags={(value, getTagProps) =>
                            value.map((option, tagIndex) => (
                              <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                {option}
                              </span>
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Working Time Zone *"
                              variant="outlined"
                              style={{ width: '520px' }}
                              helperText="Select one or more time zone by typing or choosing from the dropdown."
                              fullWidth
                            />
                          )}
                          onChange={(event, value) => handleTimeZoneChange(value)}
                        />
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Breadcrumbs
                              routes={[{ label: <span style={{ fontWeight: 'bold' }}>Current Location</span> }]}
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <FormControl variant="outlined" style={{ width: '300px' }}>
                              <InputLabel id="country-select">Country *</InputLabel>
                              <Select
                                labelId="country"
                                label="Country"
                                fullWidth
                                onChange={handleCurrentLocationCountry}
                                value={countryList.findIndex((country) => country.name === currentLocationCountry)}
                                style={{ minHeight: '44px' }}
                              >
                                {countryList.map((country, index) => (
                                  <MenuItem key={index} value={index}>
                                    {country.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <FormControl variant="outlined" style={{ width: '300px' }}>
                              <InputLabel id="state-select">State *</InputLabel>
                              <Select
                                labelId="state"
                                label="State"
                                fullWidth
                                onChange={handleCurrentLocationState}
                                value={currentStateList.findIndex((state) => state.name === currentLocationState)}
                                style={{ minHeight: '44px' }}
                              >
                                {currentStateList.map((state, index) => (
                                  <MenuItem key={index} value={index}>
                                    {state.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <FormControl variant="outlined" style={{ width: '300px' }}>
                              <InputLabel id="city-select">City *</InputLabel>
                              <Select
                                labelId="city"
                                label="City"
                                fullWidth
                                onChange={handleCurrentLocationCity}
                                value={currentCityList.findIndex((city) => city.name === location)}
                                style={{ minHeight: '44px' }}
                              >
                                {currentCityList.map((city, index) => (
                                  <MenuItem key={index} value={index}>
                                    {city.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        {/* <Grid container spacing={3}> */}
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Average Commercial (per hour) *</span> }]}
                          />
                        </Grid>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <Grid item xs={12} md={6}>
                          <FormControl variant="outlined" style={{ width: '450px' }}>
                            <InputLabel id="country-currency">Country *</InputLabel>
                            <Select
                              labelId="country-currency"
                              label="Country *"
                              fullWidth
                              onChange={handleCountryCurrencyChange}
                              value={selectedCurrencyCountry}
                              style={{ minHeight: '44px' }}
                            >
                              {getAllISOCodes().map((country) => (
                                <MenuItem key={country.iso} value={country.iso}>
                                  {country.countryName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <MKTypography variant="body2" fontWeight="regular" color="text" style={{ marginTop: "10px" }}>
                            <span>Currency: {currency}</span>
                          </MKTypography>
                        </Grid>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <Grid item xs={12} md={4}>
                          <TextField
                            label="For less than 4 hours *"
                            name="ForLessThan4hours"
                            style={{ width: "250px", borderColor: avgCommercialForLessThan4hrsError ? 'red' : undefined }}
                            onChange={(e) => {
                              setAvgCommercialForLessThan4hrs(e.target.value);
                              handleAvgCommercialForLessThan4hrsChange(e, setAvgCommercialForLessThan4hrsError);
                            }}
                            error={!avgCommercialForLessThan4hrsError}
                            value={avgCommercialForLessThan4hrs}
                            style={{ minHeight: '44px' }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            label="For 4 hours *"
                            name="For4hours"
                            style={{ width: "250px", borderColor: avgCommercialFor4hrsError ? 'red' : undefined }}
                            onChange={(e) => {
                              setAvgCommercialFor4hrs(e.target.value);
                              handleAvgCommercialFor4hrsChange(e, setAvgCommercialFor4hrsError);
                            }}
                            error={!avgCommercialFor4hrsError}
                            value={avgCommercialFor4hrs}
                            style={{ minHeight: '44px' }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            label="For 8 hours *"
                            name="For8hours"
                            style={{ width: "250px", borderColor: avgCommercialFor8hrsError ? 'red' : undefined }}
                            onChange={(e) => {
                              setAvgCommercialFor8hrs(e.target.value);
                              handleAvgCommercialFor8hrsChange(e, setAvgCommercialFor8hrsError);
                            }}
                            error={!avgCommercialFor8hrsError}
                            value={avgCommercialFor8hrs}
                            style={{ minHeight: '44px' }}
                            fullWidth
                          />
                        </Grid>
                        {/* </Grid> */}
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
                        <Grid item xs={12} sm={3}>
                          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                            Are you willing to travel within your country ? *
                          </MKTypography>
                        </Grid>
                        <FormControl component="fieldset" style={{ marginLeft: '100px', marginTop: '-5px' }}>
                          <RadioGroup row aria-label="travelWithinCountry" name="travelWithinCountry" value={travelWithinCountry} onChange={handleTravelWithinCountryChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
                        <Grid item xs={12} sm={3}>
                          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                            Are you willing to travel outside your country ? *
                          </MKTypography>
                        </Grid>
                        <FormControl component="fieldset" style={{ marginLeft: '100px', marginTop: '-5px' }}>
                          <RadioGroup row aria-label="travelOutsideCountry" name="travelOutsideCountry" value={travelOutsideCountry} onChange={handleTravelOutsideCountryChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
                        <Grid item xs={12} sm={3}>
                          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                            Are you willing to provide training on weekend ? *
                          </MKTypography>
                        </Grid>
                        <FormControl component="fieldset" style={{ marginLeft: '100px', marginTop: '-5px' }}>
                          <RadioGroup row aria-label="weekedTraining" name="weekedTraining" value={weekedTraining} onChange={handleWeekedTrainingChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
                        <Grid item xs={12} sm={3}>
                          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                            Are you willing to provide individual training ? *
                          </MKTypography>
                        </Grid>
                        <FormControl component="fieldset" style={{ marginLeft: '100px', marginTop: '-5px' }}>
                          <RadioGroup row aria-label="individualTraining" name="individualTraining" value={individualTraining} onChange={handleIndividualTrainingChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
                        <Grid item xs={12} sm={3}>
                          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                            Are you ok with recording the Training ? *
                          </MKTypography>
                        </Grid>
                        <FormControl component="fieldset" style={{ marginLeft: '100px', marginTop: '-5px' }}>
                          <RadioGroup row aria-label="individualTraining" name="individualTraining" value={recordTraining} onChange={handleRecordTrainingChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Profile (A brief introduction about yourself, 100 to 1000 characters)*"
                            multiline
                            rows={4}
                            variant="outlined"
                            style={{
                              width: "520px",
                              borderColor: profileDescription.length >= 100 && profileDescription.length <= 1000 && isFieldProfileInteracted
                                ? "initial"
                                : "initial", // Change this to your desired default border color
                            }}
                            fullWidth
                            error={isFieldProfileInteracted && (profileDescription.length < 100 || profileDescription.length > 1000)}
                            helperText={
                              isFieldProfileInteracted && (profileDescription.length < 100 || profileDescription.length > 1000)
                                ? ""
                                : ""
                            }
                            value={profileDescription}
                            onChange={handleProfileChange}
                            onFocus={() => setIsFieldProfileInteracted(true)}
                          />
                        </div>
                        <div>
                          <MKTypography style={{ marginBottom: '10px', fontSize: '14px', whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                            Upload Resume *
                          </MKTypography>
                          <input
                            type="file"
                            id="resume-upload"
                            accept="pdf/*"
                            style={{ display: 'none' }}
                            ref={resumeFileInputRef}
                            onChange={handleResumeUploadChange}
                          />
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label htmlFor="resume-upload">
                              <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small">
                                Upload
                              </MKButton>
                            </label>
                            {resume && (
                              <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                <span> {resume.name}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        {resumeError && (
                          <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                            {resumeError}
                          </MKTypography>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleGeneralInformationNextClick} disabled={!generalInfoValid || resumeError || profilePictureError}>NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 4 && (
                  <div>
                    <Typography style={{ marginBottom: "20px" }}>Personal Details</Typography>
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <div>
                        <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>
                          Date of Birth *
                        </InputLabel>
                        <MKInput
                          type="date"
                          id="date_ofBirth"
                          value={personalDetails.dob || ""}
                          onChange={handleDOBChange}
                          style={{ width: "250px", minHeight: '30px', borderColor: ageValidationError ? 'red' : undefined }}
                          placeholder={personalDetails.dob ? "" : "Date of Birth"}
                          inputProps={{ max: today }}
                        // fullwidth
                        />
                      </div>
                      <div>
                        {/* <InputLabel style={{ marginBottom: "20px" }}></InputLabel> */}
                        <FormControl variant="outlined" style={{ width: '250px' }}>
                          <InputLabel id="gender">Gender *</InputLabel>
                          <Select
                            labelId="gender"
                            label="Gender"
                            // fullWidth
                            onChange={handleGenderChange}
                            value={gender}
                            style={{ minHeight: '44px' }}
                          >
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Transgender">Transgender</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        <FormControl variant="outlined" style={{ width: '250px' }}>
                          <InputLabel id="martial-status">Martial Status</InputLabel>
                          <Select
                            labelId="martial-status"
                            label="Martial Status"
                            // fullWidth
                            onChange={handleMartialStatusChange}
                            style={{ minHeight: '44px' }}
                          >
                            <MenuItem value="Single">Single</MenuItem>
                            <MenuItem value="Married">Married</MenuItem>
                            <MenuItem value="Divorced">Divorced</MenuItem>
                            <MenuItem value="Widowed">Widowed</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    {ageValidationError && (
                      <span style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                        You should be above 18 years to create your profile.
                      </span>
                    )}
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Emergency Contact Details</span> }]}
                        />
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <MKButton variant="gradient" color="info" onClick={openEmgSalutationDropdown}>
                          {emgSalutation || 'Salutation *'} <Icon>expand_more</Icon>
                        </MKButton>
                        <Menu anchorEl={emgSalutationDropdown} open={Boolean(emgSalutationDropdown)} onClose={closeEmgSalutationDropdown}>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Mr.')}>Mr.</MenuItem>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Mrs.')}>Mrs.</MenuItem>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Miss.')}>Miss.</MenuItem>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Ms.')}>Ms.</MenuItem>
                        </Menu>
                      </div>
                      <div>
                        <TextField
                          label="First Name *"
                          variant="outlined"
                          style={{ width: "250px", borderColor: emgFirstNameError ? 'red' : undefined }}
                          // fullWidth
                          value={personalDetails.emgFirstName}
                          onChange={(e) => {
                            const input = e.target.value;
                            const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
                            const isValid = !regex.test(input);
                            setEmgFirstNameError(isValid);
                            setPersonalDetails((prevDetails) => ({
                              ...prevDetails,
                              emgFirstName: e.target.value,
                            }));
                          }}
                          error={!emgFirstNameError}
                        />
                      </div>
                      <div>
                        <TextField
                          label="Last Name *"
                          variant="outlined"
                          style={{ width: "250px", borderColor: emgLastNameError ? 'red' : undefined }}
                          // fullWidth
                          value={personalDetails.emgLastName}
                          onChange={(e) => {
                            const input = e.target.value;
                            const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
                            const isValid = !regex.test(input);
                            setEmgLastNameError(isValid);
                            setPersonalDetails((prevDetails) => ({
                              ...prevDetails,
                              emgLastName: e.target.value,
                            }));
                          }}
                          error={!emgLastNameError}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <FormControl variant="outlined" style={{ width: '250px' }}>
                          <InputLabel id="EmergencyContactCountry">Emergency Contact Country *</InputLabel>
                          <Select
                            labelId="EmergencyContactCountry"
                            label="Emergency Contact Country"
                            // fullWidth
                            onChange={handleEmgContactCountryChange}
                            value={selectedEmgContactCountry}
                            style={{ minHeight: '44px' }}
                          >
                            {CountryList.getAll().map((country) => (
                              <MenuItem key={country.name} value={country.name}>
                                {country.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        <TextField
                          label="Code *"
                          name="Code"
                          value={emgContactCountryCode}
                          InputProps={{
                            readOnly: true,
                          }}
                          style={{ width: '250px', minHeight: '44px' }}
                        // fullWidth
                        />
                      </div>
                      <div>
                        <TextField
                          label="Emergency Contact Number *"
                          variant="outlined"
                          style={{ width: "250px", borderColor: emergencyNumberError ? 'red' : undefined }}
                          onChange={(e) => {
                            setEmergencyNumber(e.target.value);
                            handleEmergencyNumberChange(e, setEmergencyNumberError);
                          }}
                          error={!emergencyNumberError}
                          value={emergencyNumber}
                        // fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Additional Contact Details</span> }]}
                        />
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <MKButton variant="gradient" color="info" onClick={openSecSalutationDropdown}>
                          {secSalutation || 'Salutation'} <Icon>expand_more</Icon>
                        </MKButton>
                        <Menu anchorEl={secSalutationDropdown} open={Boolean(secSalutationDropdown)} onClose={closeSecSalutationDropdown}>
                          <MenuItem onClick={() => handleSecSalutationSelect('Mr.')}>Mr.</MenuItem>
                          <MenuItem onClick={() => handleSecSalutationSelect('Mrs.')}>Mrs.</MenuItem>
                          <MenuItem onClick={() => handleSecSalutationSelect('Miss.')}>Miss.</MenuItem>
                          <MenuItem onClick={() => handleSecSalutationSelect('Ms.')}>Ms.</MenuItem>
                        </Menu>
                      </div>
                      <div>
                        <TextField
                          label="First Name"
                          variant="outlined"
                          style={{ width: "250px", borderColor: secFirstNameError ? 'red' : undefined }}
                          // fullWidth
                          value={personalDetails.secFirstName}
                          onChange={(e) => {
                            const input = e.target.value;
                            const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
                            const isValid = !regex.test(input);
                            setSecFirstNameError(isValid);
                            setPersonalDetails((prevDetails) => ({
                              ...prevDetails,
                              secFirstName: e.target.value,
                            }));
                          }}
                          error={!secFirstNameError}
                        />
                      </div>
                      <div>
                        <TextField
                          label="Last Name"
                          variant="outlined"
                          style={{ width: "250px", borderColor: secLastNameError ? 'red' : undefined }}
                          // fullWidth
                          value={personalDetails.secLastName}
                          onChange={(e) => {
                            const input = e.target.value;
                            const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
                            const isValid = !regex.test(input);
                            setSecLastNameError(isValid);
                            setPersonalDetails((prevDetails) => ({
                              ...prevDetails,
                              secLastName: e.target.value,
                            }));
                          }}
                          error={!secLastNameError}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <FormControl variant="outlined" style={{ width: '250px' }}>
                          <InputLabel id="SecondaryContactCountry">Secondary Contact Country</InputLabel>
                          <Select
                            labelId="SecondaryContactCountry"
                            label="Secondary Contact Country"
                            // fullWidth
                            onChange={handleSecContactCountryChange}
                            value={selectedSecContactCountry}
                            style={{ minHeight: '44px' }}
                          >
                            {CountryList.getAll().map((country) => (
                              <MenuItem key={country.name} value={country.name}>
                                {country.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        <TextField
                          label="Code"
                          name="Code"
                          value={secContactCountryCode}
                          InputProps={{
                            readOnly: true,
                          }}
                          style={{ width: '250px', minHeight: '44px' }}
                        // fullWidth
                        />
                      </div>
                      <div>
                        <TextField
                          label="Secondary Contact Number"
                          variant="outlined"
                          style={{ width: "250px", borderColor: secondaryNumberError ? 'red' : undefined }}
                          onChange={(e) => {
                            setSecondaryNumber(e.target.value);
                            handleSecondaryNumberChange(e, setSecondaryNumberError);
                          }}
                          error={!secondaryNumberError}
                          value={secondaryNumber}
                        // fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <TextField
                          label="Govt Id No (Aadhar/SSN)"
                          variant="outlined"
                          style={{ width: "250px" }}
                          onChange={(e) => {
                            setAadharNumber(e.target.value);
                            handleAadharNumberChange(e);
                          }}
                          value={aadharNumber}
                        // fullWidth
                        />
                      </div>
                      <div>
                        <TextField
                          label="Tax Number (Pan/Tax)"
                          variant="outlined"
                          style={{ width: "250px" }}
                          onChange={(e) => {
                            setPanNumber(e.target.value);
                            handlePanNumberChange(e);
                          }}
                          value={panNumber}
                        // fullWidth
                        />
                      </div>
                      <div>
                        <TextField
                          label="Passport Number"
                          variant="outlined"
                          style={{ width: "250px", borderColor: passportNumberError ? 'red' : undefined }}
                          onChange={(e) => {
                            setPassportNumber(e.target.value);
                            handlePassportNumberChange(e, setPassportNumberError);
                          }}
                          error={!passportNumberError}
                          value={passportNumber}
                        // fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <Grid container alignItems="center" style={{ marginTop: '5px' }}>
                          <Grid item xs={12} sm={3}>
                            <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                              Are you currently holding any Visa?
                            </MKTypography>
                          </Grid>
                          <Grid item>
                            <FormControl component="fieldset" style={{ marginLeft: '150px', marginTop: '-5px' }}>
                              <RadioGroup row aria-label="visa" name="visa" value={visa} onChange={handleVisaChange}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                  <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                                  <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                                </Box>
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', margin: '20px 0' }}>
                      {visa === "yes" && (
                        <>
                          {visaInfo.map((info, index) => (
                            <div key={index} style={{ display: "flex", gap: "20px" }}>
                              <div>
                                <FormControl variant="outlined" style={{ width: '250px' }}>
                                  <InputLabel id="country-select">Country *</InputLabel>
                                  <Select
                                    labelId="country"
                                    label={`Country ${index + 1}`}
                                    fullWidth
                                    onChange={(e) => handleCountryChange(index, e.target.value)}
                                    value={info.country}
                                    style={{ minHeight: '44px' }}
                                  >
                                    {CountryList.getAll().map((country) => (
                                      <MenuItem key={country.name} value={country.name}>
                                        {country.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                              <div>
                                <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>From Date *</InputLabel>
                                <MKInput
                                  type="date"
                                  id="from_date"
                                  // label="From Date *"
                                  value={info.fromDate || ""}
                                  onChange={(e) => handleFromDateChange(index, e.target.value)}
                                  style={{ width: "250px" }}
                                  placeholder="From Date"
                                // fullwidth
                                />
                              </div>
                              <div>
                                <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>To Date *</InputLabel>
                                <MKInput
                                  type="date"
                                  id="to_date"
                                  // label="To Date *"
                                  value={info.toDate || ""}
                                  onChange={(e) => handleToDateChange(index, e.target.value)}
                                  style={{ width: "250px" }}
                                  placeholder="To Date"
                                // fullwidth
                                />
                              </div>
                              {isNewVisaInfoAdded && visaInfo.length > 1 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "5px" }}>
                                  <MKAvatar src={deleteIcon} alt="sm" size="sm" onClick={() => handleDeleteVisaInfo(index)} />
                                </div>
                              )}
                              {index === visaInfo.length - 1 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "50px" }}>
                                  <MKAvatar src={add} alt="sm" size="sm" onClick={handleAddVisaInfo} />
                                </div>
                              )}
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Address</span> }]}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Address Line 1 *( Door No, Street Name )"
                            name="addressLine1"
                            value={address.addressLine1}
                            onChange={handleAddressChange}
                            style={{ width: '450px', minHeight: '44px' }}
                          // fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Address Line 2 *( Area / Locality )"
                            name="addressLine2"
                            value={address.addressLine2}
                            onChange={handleAddressChange}
                            style={{ width: '425px', minHeight: '44px' }}
                          // fullWidth
                          />
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" style={{ width: '210px' }}>
                            <InputLabel id="country-select">Country *</InputLabel>
                            <Select
                              labelId="country"
                              label="Country"
                              // fullWidth
                              onChange={handleAddressCountryChange}
                              value={countryList.findIndex((country) => country.name === address.country)}
                              style={{ minHeight: '44px' }}
                            >
                              {countryList.map((country, index) => (
                                <MenuItem key={index} value={index}>
                                  {country.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" style={{ width: '210px' }}>
                            <InputLabel id="state-select">State *</InputLabel>
                            <Select
                              labelId="state"
                              label="State"
                              // fullWidth
                              onChange={handleStateChange}
                              value={stateList.findIndex((state) => state.name === address.state)}
                              style={{ minHeight: '44px' }}
                            >
                              {stateList.map((state, index) => (
                                <MenuItem key={index} value={index}>
                                  {state.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" style={{ width: '210px' }}>
                            <InputLabel id="city-select">City *</InputLabel>
                            <Select
                              labelId="city"
                              label="City"
                              // fullWidth
                              onChange={handleCityChange}
                              value={cityList.findIndex((city) => city.name === address.city)}
                              style={{ minHeight: '44px' }}
                            >
                              {cityList.map((city, index) => (
                                <MenuItem key={index} value={index}>
                                  {city.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="Pincode / Zipcode *"
                            name="pincode"
                            value={address.pincode}
                            onChange={handleAddressChange}
                            style={{ minHeight: '44px' }}
                          // fullWidth
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Languages Known</span> }]}
                          />
                        </Grid>

                        <Grid item xs={12} md={3}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Language</span> }]}
                          />
                          {/* <h4>Language</h4> */}
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Read</span> }]}
                          />
                          {/* <h4>Read</h4> */}
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Write</span> }]}
                          />
                          {/* <h4>Write</h4> */}
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Speak</span> }]}
                          />
                          {/* <h4>Speak</h4> */}
                        </Grid>

                        {languages.map((language, index) => (
                          <React.Fragment key={index}>
                            <Grid item xs={12} md={3} justifyContent="center">
                              <FormControl variant="outlined" style={{ width: '210px' }}>
                                <InputLabel id={`language-${index + 1}-label`}>Language {index + 1}</InputLabel>
                                <Select
                                  labelId={`language-${index + 1}-label`}
                                  label={`Language ${index + 1}`}
                                  // fullWidth
                                  value={language.language}
                                  onChange={(e) => handleLanguageChange(index, 'language', e.target.value)}
                                  style={{ minHeight: '44px' }}
                                >
                                  {languageList.map((lang, langIndex) => (
                                    <MenuItem key={langIndex} value={lang.name}>
                                      {lang.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3} container justifyContent="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={language.read === 'true'}
                                    onChange={(e) => handleLanguageChange(index, 'read', e.target.checked)}
                                  />
                                }
                              // label="Read"
                              />
                            </Grid>
                            <Grid item xs={12} md={3} container justifyContent="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={language.write === 'true'}
                                    onChange={(e) => handleLanguageChange(index, 'write', e.target.checked)}
                                  />
                                }
                              // label="Write"
                              />
                            </Grid>
                            <Grid item xs={12} md={3} container justifyContent="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={language.speak === 'true'}
                                    onChange={(e) => handleLanguageChange(index, 'speak', e.target.checked)}
                                  />
                                }
                              // label="Speak"
                              />
                              {isNewLanguageAdded && languages.length > 1 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: "0px" }}>
                                  <MKAvatar src={deleteIcon} alt="sm" size="sm" onClick={() => handleDeleteLanguage(index)} />
                                </div>
                              )}
                              {index === languages.length - 1 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: "5px" }}>
                                  <MKAvatar src={add} alt="sm" size="sm" onClick={handleAddLanguage} />
                                </div>
                              )}
                            </Grid>

                          </React.Fragment>

                        ))}
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
                      <Grid item xs={12} sm={3}>
                        <MKTypography style={{ whiteSpace: 'nowrap' }} variant="body2" fontWeight="regular" color="text">
                          Are you differently abled ? *
                        </MKTypography>
                      </Grid>
                      <FormControl component="fieldset" style={{ marginLeft: '30px', marginTop: '-5px' }}>
                        <RadioGroup row aria-label="differently_abled" name="differently_abled" value={differentlyAbled} onChange={handleDifferentlyAbledChange}>
                          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                            <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                          </Box>
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div style={{ display: 'flex', marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handlePersonalDetailsNextClick} disabled={!personalInfoValid || (visa === "yes" && !isVisaInfoFilled)}>NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 5 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Work Experience</Typography>
                    <div>
                      {jobProfiles.map((profile, index) => (
                        <div key={index}>
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <div >
                              <Autocomplete
                                // multiple
                                id={`client-${index}`}
                                options={clientName}
                                freeSolo
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => (
                                    <span key={index} {...getTagProps({ index })}>
                                      {option}
                                    </span>
                                  ))
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Company Name"
                                    variant="outlined"
                                    style={{ width: '520px' }}
                                  />
                                )}
                                onChange={(e, value) => handleJobProfileChange(e, index, 'companyName', value)}
                              />
                            </div>
                            {isNewJobProfileAdded && jobProfiles.length > 1 && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "5px" }}>
                                <MKAvatar src={deleteIcon} style={{ cursor: 'pointer' }} alt="sm" size="sm" onClick={() => handleDeleteJobProfile(index)} />
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div >
                              <Autocomplete
                                multiple
                                id={`skills-${index}`}
                                options={skillsName}
                                freeSolo
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => (
                                    <span key={index} {...getTagProps({ index })}>
                                      {option}
                                    </span>
                                  ))
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Skills"
                                    variant="outlined"
                                    style={{ width: '520px' }}
                                    helperText="Select one or more technology by typing or choosing from the dropdown."
                                  // fullWidth
                                  />
                                )}
                                onChange={(event, value) =>
                                  handleJobProfileChange(event, index, 'technology', value.join(', '))
                                }
                              />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <TextField
                                label="Designation"
                                variant="outlined"
                                style={{ width: "250px" }}
                                onChange={(e) => handleJobProfileChange(e, index, 'designation', e.target.value)}
                                // onChange={handleDesignationChange}
                                value={profile.designation}
                              // fullWidth
                              />
                            </div>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel id="martial-status">Employment Type</InputLabel>
                                <Select
                                  labelId="employment-type"
                                  label="Employment Type"
                                  // fullWidth
                                  onChange={(e) => handleJobProfileChange(e, index, 'employmentType', e.target.value)}
                                  // onChange={handleEmploymentTypeChange}
                                  style={{ minHeight: '44px' }}
                                  value={profile.employmentType}
                                >
                                  <MenuItem value="Part-Time">Part-Time</MenuItem>
                                  <MenuItem value="Full-Time">Full-Time</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '30px 0' }}>
                            <div>
                              <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Date of Joining</InputLabel>
                              <MKInput
                                type="date"
                                id="date_ofJoining"
                                // label="Date of Joining *"
                                value={profile.dateOfJoining || ""}
                                onChange={(e) => handleJobProfileChange(e, index, 'dateOfJoining', e.target.value)}
                                // onChange={handleDateOfJoiningChange}
                                style={{ width: "250px" }}
                                placeholder="Date of Joining"
                                inputProps={{ max: today }}
                              // fullwidth
                              />
                            </div>
                            <div>
                              <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Date of Leaving</InputLabel>
                              <MKInput
                                type="date"
                                id="date_ofLeaving"
                                // label="Date of Leaving *"
                                value={profile.dateOfLeaving || ""}
                                onChange={(e) => handleJobProfileChange(e, index, 'dateOfLeaving', e.target.value)}
                                // onChange={handleDateOfLeavingChange}
                                style={{ width: "250px" }}
                                placeholder="Date of Leaving"
                                inputProps={{ max: today }}
                              // fullwidth
                              />
                            </div>
                          </div>

                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0', marginTop: "-10px" }}>
                            <div>
                              <TextField
                                label="Job Profile"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{ width: "520px" }}
                                // fullwidth
                                value={profile.jobProfile}
                                onChange={(e) => handleJobProfileChange(e, index, 'jobProfile', e.target.value)}
                              // onChange={handleJobProfileChange}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddJobProfile} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Work Expereince</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-45px", marginBottom: "10px" }}>
                      {jobProfiles.some(profile => Object.values(profile).some(value => value && value !== profile.trainerProfileID)) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" onClick={handleWorkExperienceNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleWorkExperienceSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" disabled onClick={handleWorkExperienceNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" style={{ margin: "0 10px" }} color="info" onClick={handleWorkExperienceSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 3 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Training Experience</Typography>
                    {trainingExperience.map((trainingExperience, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', gap: '20px' }}>
                          <div>
                            <TextField
                              label="Profile Name *"
                              variant="outlined"
                              // style={{ borderColor: totalNoOfTrainingsError ? 'red' : undefined }}
                              onChange={(event) => handleProfileNameChange(event, index)}
                              value={trainingExperience.profileName}
                              style={{ width: "250px", minHeight: '44px' }}
                            // error={!totalNoOfTrainingsError}
                            // fullWidth
                            />
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {isNewTrainingExperienceAdded && fieldSets.length > 1 && (
                              <div style={{ marginRight: "5px" }}>
                                <MKAvatar src={deleteIcon} style={{ cursor: 'pointer' }} alt="sm" size="sm" onClick={() => handleDeleteTrainingExperience(index)} />
                              </div>
                            )}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '25px 0' }}>
                          <div >
                            <Autocomplete
                              multiple
                              id={`skills-${index}`}
                              options={skillsName}
                              freeSolo
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <span key={index} {...getTagProps({ index })}>
                                    {option}
                                  </span>
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Skills *"
                                  variant="outlined"
                                  style={{ width: '520px' }}
                                  helperText="Select one or more technology by typing or choosing from the dropdown."
                                  fullWidth
                                />
                              )}
                              onChange={(event, value) => handleTrainingTechnologyChange(event, index, value)}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '25px 0' }}>
                          <div >
                            <Autocomplete
                              multiple
                              id={`client-${index}`}
                              options={clientName}
                              freeSolo
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <span key={index} {...getTagProps({ index })}>
                                    {option}
                                  </span>
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Cients Delivered *"
                                  variant="outlined"
                                  style={{ width: '520px' }}
                                  helperText="Select one or more clients by typing or choosing from the dropdown."
                                  fullWidth
                                />
                              )}
                              onChange={(event, value) => handleClientDeliveredChange(event, index, value)}
                            />
                            <MKTypography variant="caption" color="textSecondary" style={{ marginLeft: "10px", marginTop: '-10px' }}>
                              Please select <strong>Undisclosed</strong> if you dont want to reveal your client name.
                            </MKTypography>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '25px 0' }}>
                          <div>
                            <TextField
                              label="Standard Training Duration (in hours) *"
                              variant="outlined"
                              // style={{ borderColor: totalNoOfTrainingsError ? 'red' : undefined }}
                              onChange={(event) => handleStandardTrainingDuration(event, index)}
                              value={trainingExperience.trainingDuration}
                              style={{ width: "520px", minHeight: '44px' }}
                              // error={!totalNoOfTrainingsError}
                              InputProps={{ inputProps: { min: 0 } }}
                              type="number"
                            // fullWidth
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '25px 0' }}>
                          <div>
                            <TextField
                              label="Total No of Trainings *"
                              variant="outlined"
                              style={{ borderColor: totalNoOfTrainingsError ? 'red' : undefined }}
                              onChange={(event) => handleTotalNoOfTrainingsChange(event, index)}
                              value={trainingExperience.totalNoOfTrainings}
                              InputProps={{ inputProps: { min: 0 } }}
                              style={{ width: "250px", minHeight: '44px' }}
                              error={!totalNoOfTrainingsError}
                              type="number"
                            // fullWidth
                            />
                          </div>
                          <div>
                            <FormControl variant="outlined" style={{ width: '250px' }}>
                              <InputLabel id="delivery-method">Delivery Method *</InputLabel>
                              <Select
                                labelId="delivery-method"
                                label="Delivery Method *"
                                // fullWidth
                                onChange={(event) => handleDeliveryMethodChange(event, index)}
                                value={trainingExperience.deliveryMethod}
                                style={{ minHeight: '44px' }}
                              >
                                <MenuItem value="Online">Online</MenuItem>
                                <MenuItem value="Classroom">Classroom</MenuItem>
                                <MenuItem value="Online,Classroom">Both</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '25px 0' }}>
                          <div>
                            <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>
                              Date of Last Training *
                            </InputLabel>
                            <TextField
                              type="month"
                              id="date_ofLastTraining"
                              value={trainingExperience.dateOfLastTraining || ''}
                              onChange={(event) => handleDateOfLastTrainingChange(event, index)}
                              style={{ width: "250px" }}
                              InputProps={{
                                inputProps: {
                                  max: new Date().toISOString().split('T')[0].substring(0, 7),
                                },
                              }}
                            // fullwidth
                            />
                          </div>
                          <div>
                            <TextField
                              label="Total Training Experience (in months)"
                              variant="outlined"
                              style={{ width: '250px' }}
                              // fullWidth
                              onChange={(event) => handleTotalTrainingExperienceChange(event, index)}
                              value={trainingExperience.totalTrainingExperience}
                              InputProps={{ inputProps: { min: 0 } }}
                              type="number"
                              required
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <TextField
                              label="Demo Video Link"
                              variant="outlined"
                              style={{ width: '520px' }}
                              // fullWidth
                              value={trainingExperience.demoLink}
                              onChange={(event) => handleDemoLinkChange(event, index)}
                            // onChange={(e) => handleDemoLinkChange(e.target.value)}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '14px' }}>
                          <div style={{ fontSize: '14px' }}>
                            Feedback Screenshot ( in .png or .jpeg or .jpg )
                          </div>
                          <input
                            type="file"
                            id={`feedback-upload-${index}`}
                            accept="image/*"
                            style={{ display: 'none' }}
                            ref={feedbackFileInputRef}
                            onChange={handleFeedbackUploadChange(index)}
                          />
                          <div style={{ display: 'flex', alignItems: 'center', marginLeft: "10px" }}>
                            <label htmlFor="feedback-upload">
                              <MKButton onClick={handleFeedbackUploadClick} variant="gradient" color="info" size="small">
                                Upload Screenshot
                              </MKButton>
                            </label>
                            {feedbacks[index].map((uploadedFeedback, feedbackIndex) => (
                              <div key={feedbackIndex} style={{ fontSize: '14px', marginLeft: "10px" }}>
                                <span> {uploadedFeedback.name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                        {feedbackError && (
                          <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                            {feedbackError}
                          </MKTypography>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '14px' }}>
                          <div style={{ fontSize: '14px' }}>
                            Standard TOC ( in .pdf or .docx or .xlsx or .xls )
                          </div>
                          <input
                            type="file"
                            id={`toc-upload-${index}`}
                            accept="pdf/*"
                            style={{ display: 'none' }}
                            ref={tocFileInputRef}
                            onChange={handleTocUploadChange(index)}
                          />
                          <div style={{ display: 'flex', alignItems: 'center', marginLeft: "10px" }}>
                            <label htmlFor="toc-upload">
                              <MKButton onClick={handleTocUploadClick} variant="gradient" color="info" size="small">
                                Upload Toc
                              </MKButton>
                            </label>
                            {tocs[index].map((uploadedtoc, tocIndex) => (
                              <div key={tocIndex} style={{ fontSize: '14px', marginLeft: "10px" }}>
                                <span> {uploadedtoc.name}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                        {tocError && (
                          <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                            {tocError}
                          </MKTypography>
                        )}
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Consulting</span> }]}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <TextField
                              label="Project Title"
                              variant="outlined"
                              style={{ width: '520px' }}
                              // fullWidth
                              value={trainingExperience.projectTitle}
                              onChange={(event) => handleTitleChange(event, index)}
                            // onChange={(e) => handleTitleChange(index, e.target.value)}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <TextField
                              label="Project Description (100 to 1000 characters)"
                              multiline
                              rows={4}
                              variant="outlined"
                              style={{
                                width: "520px",
                                borderColor: trainingExperience.projectDescription.length >= 100 && trainingExperience.projectDescription.length <= 1000 && isFieldProjectInteracted
                                  ? "initial"
                                  : "initial", // Change this to your desired default border color
                              }}
                              error={isFieldProjectInteracted && (trainingExperience.projectDescription.length < 100 || trainingExperience.projectDescription.length > 1000)}
                              helperText={
                                isFieldProjectInteracted && (trainingExperience.projectDescription.length < 100 || trainingExperience.projectDescription.length > 1000)
                                  ? ""
                                  : ""
                              }
                              value={trainingExperience.projectDescription}
                              onChange={(event) => handleDescriptionChange(event, index)}
                              // onChange={(e) => handleDescriptionChange(index, e.target.value)}
                              onFocus={() => setIsFieldProjectInteracted(true)}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Commercial ( per hour ) *</span> }]} />
                            </Grid>
                          </Grid>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <Grid item xs={12} md={6}>
                            <FormControl variant="outlined" style={{ width: '520px' }}>
                              <InputLabel id="commercials-currency">Country *</InputLabel>
                              <Select
                                labelId="commercials-currency"
                                label="Country"
                                // fullWidth
                                onChange={(event) => handleCommercialsCurrencyChange(event, index)}
                                // onChange={handleCommercialsCurrencyChange}
                                value={trainingExperience.selectedCommercialsCurrency}
                                style={{ minHeight: '44px' }}
                              >
                                {getAllISOCodes().map((country) => (
                                  <MenuItem key={country.iso} value={country.iso}>
                                    {country.countryName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <MKTypography variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "90px", marginTop: "10px" }}>
                              <span>Currency: {currencies[index]}</span>
                            </MKTypography>
                          </Grid>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="For Less than 4 hours *"
                              name="forLessThan4hrs"
                              value={trainingExperience.forLessThan4hrs}
                              onChange={(event) => handleForLessThan4hrsChange(event, index)}
                              // onChange={handleForLessThan4hrsChange}
                              style={{ width: "250px", minHeight: '44px', borderColor: commercialForLessThan4hrsError ? 'red' : undefined }}
                              error={!commercialForLessThan4hrsError}
                            // fullWidth
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="For 4 hours *"
                              name="for4hrs"
                              value={trainingExperience.for4hrs}
                              // onChange={handleFor4hrsChange}
                              style={{ width: "250px" }}
                              onChange={(event) => handleFor4hrsChange(event, index)}
                              style={{ width: "250px", minHeight: '44px', borderColor: commercialFor4hrsError ? 'red' : undefined }}
                              error={!commercialFor4hrsError}
                            // fullWidth
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              label="For 8 hours *"
                              name="for8hrs"
                              value={trainingExperience.for8hrs}
                              // onChange={handleFor8hrsChange}
                              onChange={(event) => handleFor8hrsChange(event, index)}
                              style={{ width: "250px", minHeight: '44px', borderColor: commercialFor8hrsError ? 'red' : undefined }}
                              error={!commercialFor8hrsError}
                            // fullWidth
                            />
                          </Grid>
                        </div>
                      </div>
                    ))}
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddTrainingExperience} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Training Experience</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-45px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleTrainingExperienceNextClick} disabled={!trainingExpInfoValid || feedbackError || tocError}>NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 8 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Education</Typography>
                    <div>
                      {educationList.map((education, index) => (
                        <div key={index}>
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <div>
                              <TextField
                                label="Education"
                                variant="outlined"
                                style={{ width: "250px" }}
                                fullWidth
                                value={education.education}
                                onChange={(e) => handleEducationChange(index, 'education', e.target.value)}
                              />
                            </div>
                            <div>
                              <TextField
                                label="Institute / University"
                                variant="outlined"
                                style={{ width: "250px" }}
                                fullWidth
                                value={education.university}
                                onChange={(e) => handleEducationChange(index, 'university', e.target.value)}
                              />
                            </div>
                            {isNewEducationAdded && educationList.length > 1 && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "5px" }}>
                                <MKAvatar src={deleteIcon} style={{ cursor: 'pointer' }} alt="sm" size="sm" onClick={() => handleDeleteEducation(index)} />
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <TextField
                                label="Course"
                                variant="outlined"
                                style={{ width: "250px" }}
                                fullWidth
                                value={education.course}
                                onChange={(e) => handleEducationChange(index, 'course', e.target.value)}
                              />
                            </div>
                            <div>
                              <TextField
                                label="Specialization"
                                variant="outlined"
                                style={{ width: "250px" }}
                                fullWidth
                                value={education.specialization}
                                onChange={(e) => handleEducationChange(index, 'specialization', e.target.value)}
                              />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel id={`mode-ofLearning-${index}`}>Mode of Learning</InputLabel>
                                <Select
                                  labelId={`mode-ofLearning-${index}`}
                                  label="Mode of Learning"
                                  fullWidth
                                  style={{ minHeight: '44px' }}
                                  value={education.modeOfLearning}
                                  onChange={(e) => handleEducationChange(index, 'modeOfLearning', e.target.value)}
                                >
                                  <MenuItem value="Regular">Regular</MenuItem>
                                  <MenuItem value="Distance">Distance</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <div>
                              <TextField
                                label="Grade / Mark in Percentage"
                                variant="outlined"
                                style={{ width: "250px" }}
                                fullWidth
                                value={education.mark}
                                onChange={(e) => handleEducationChange(index, 'mark', e.target.value)}
                              />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>

                            <div>

                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel id={`course-fromYear-${index}`}>From Year</InputLabel>
                                <Select
                                  label="From Year"
                                  id={`course_fromYear_${index}`}
                                  style={{ minHeight: '44px' }}
                                  placeholder="Course From Year"
                                  fullWidth
                                  value={education.fromYear}
                                  onChange={(e) => handleEducationChange(index, 'fromYear', e.target.value)}
                                >
                                  {yearOptions.map((year) => (
                                    <MenuItem key={year} value={year}>
                                      {year}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel id={`course-toYear-${index}`}>To Year</InputLabel>
                                <Select
                                  label="To Year"
                                  id={`course_toYear_${index}`}
                                  style={{ width: "250px", minHeight: '44px' }}
                                  placeholder="Course To Year"
                                  fullWidth
                                  value={education.toYear}
                                  onChange={(e) => handleEducationChange(index, 'toYear', e.target.value)}
                                >
                                  {yearOptions.map((year) => (
                                    <MenuItem key={year} value={year}>
                                      {year}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddEducation} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Eduation Details</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-45px", marginBottom: "10px" }}>
                      {educationList.some(edu => Object.values(edu).some(value => value && value !== edu.trainerProfileID)) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleEducationNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleEducationSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleEducationNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleEducationSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 6 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Certification</Typography>
                    <div>
                      {certificationList.map((certification, index) => (
                        <div key={index}>
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <div>
                              <Autocomplete
                                id={`skills-${index}`}
                                options={skillsName}
                                freeSolo
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => (
                                    <span key={index} {...getTagProps({ index })}>
                                      {option}
                                    </span>
                                  ))
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Skills"
                                    variant="outlined"
                                    style={{ width: '520px' }}
                                  // fullWidth
                                  />
                                )}
                                onChange={(event, value) =>
                                  handleCertificationChange(index, 'technology', value)
                                }
                              />
                            </div>
                            {isNewCertificationAdded && certificationList.length > 1 && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "5px" }}>
                                <MKAvatar src={deleteIcon} alt="sm" style={{ cursor: 'pointer' }} size="sm" onClick={() => handleDeleteCertification(index)} />
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <TextField
                                label="Certification Name"
                                variant="outlined"
                                style={{ width: "250px" }}
                                // fullWidth
                                value={certification.certificationName}
                                onChange={(e) => handleCertificationChange(index, 'certificationName', e.target.value)}
                              />
                            </div>
                            <div>
                              <TextField
                                label="Certification ID"
                                variant="outlined"
                                style={{ width: "250px" }}
                                // fullWidth
                                value={certification.certificationId}
                                onChange={(e) => handleCertificationChange(index, 'certificationId', e.target.value)}
                              />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <TextField
                                label="Url"
                                variant="outlined"
                                style={{ width: '520px' }}
                                // fullWidth
                                value={certification.url}
                                onChange={(e) => handleCertificationChange(index, 'url', e.target.value)}
                              />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                              <div style={{ fontSize: '14px' }}>
                                Upload Certificate
                              </div>
                              <input
                                type="file"
                                id={`certificate-upload-${index}`}
                                accept="pdf/*"
                                style={{ display: 'none' }}
                                ref={certificateFileInputRef}
                                onChange={handleCertificateUploadChange(index)}
                              />
                              <div style={{ display: 'flex', alignItems: 'center', marginLeft: "10px" }}>
                                <label htmlFor={`certificate-upload-${index}`}>
                                  <MKButton onClick={() => handleCertificateUploadClick(index)} variant="gradient" color="info" size="small">
                                    Upload
                                  </MKButton>
                                </label>
                                {certificates[index].map((uploadedCertificate, certificateIndex) => (
                                  <div key={certificateIndex} style={{ fontSize: '14px', marginLeft: "10px" }}>
                                    <span> {uploadedCertificate.name}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {certificateError && (
                              <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                {certificateError}
                              </MKTypography>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Certification Validity</span> }]}
                              />
                            </Grid>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '30px 0' }}>
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={certification.certificateNeverExpires === 'true'}
                                    onChange={(e) =>
                                      handleCertificationChange(index, 'certificateNeverExpires', e.target.checked)
                                    }
                                    color="primary"
                                  />
                                }
                                label="This Certificate never expires"
                              />
                            </div>
                            <div>
                              <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Certification Valid From</InputLabel>
                              <MKInput
                                type="date"
                                id="From Date"
                                style={{ width: "250px" }}
                                placeholder="Certification From Year"
                                // fullwidth
                                disabled={certification.certificateNeverExpires === 'true'}
                                value={certification.certificationFromYear}
                                inputProps={{ max: today }}
                                onChange={(e) =>
                                  handleCertificationChange(index, 'certificationFromYear', e.target.value)
                                }
                              />
                            </div>
                            <div>
                              <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Certification Valid Till</InputLabel>
                              <MKInput
                                type="date"
                                id="To Date"
                                style={{ width: "250px" }}
                                placeholder="Certification To Year"
                                // fullwidth
                                disabled={certification.certificateNeverExpires === 'true'}
                                value={certification.certificationToYear}
                                inputProps={{ min: today }}
                                onChange={(e) =>
                                  handleCertificationChange(index, 'certificationToYear', e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddCertification} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Certifications</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-45px", marginBottom: "10px" }}>
                      {certificationList.some(certification => (
                        Object.entries(certification).some(([key, value]) => key !== 'trainerProfileID' && key !== 'certificateNeverExpires' && value)
                      ) || certificationList.every(certification => certification.certificateNeverExpires === 'true')) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled={certificateError} onClick={handleCertificateNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleCertificateSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleCertificateNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleCertificateSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>

                  </div>
                )}
                {currentStep === 7 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Reference</Typography>
                    {referenceList.map((reference, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <MKButton variant="gradient" color="info" onClick={openReferenceSalutationDropdown}>
                              {reference.referredBySalutation || 'Salutation'} <Icon>expand_more</Icon>
                            </MKButton>
                            <Menu anchorEl={referenceSalutationDropdown} open={Boolean(referenceSalutationDropdown)} onClose={closeReferenceSalutationDropdown}>
                              <MenuItem onClick={() => handleReferenceSalutationSelect('Mr.')}>Mr.</MenuItem>
                              <MenuItem onClick={() => handleReferenceSalutationSelect('Mrs.')}>Mrs.</MenuItem>
                              <MenuItem onClick={() => handleReferenceSalutationSelect('Miss.')}>Miss.</MenuItem>
                              <MenuItem onClick={() => handleReferenceSalutationSelect('Ms.')}>Ms.</MenuItem>
                            </Menu>
                          </div>
                          <div>
                            <TextField
                              label="First Name"
                              variant="outlined"
                              style={{
                                width: "250px",
                                borderColor: reference.referredByFirstName && !isValidAlphabet(reference.referredByFirstName) ? 'red' : undefined
                              }}
                              fullWidth
                              value={reference.referredByFirstName}
                              onChange={(e) => handleReferenceChange(index, 'referredByFirstName', e.target.value)}
                              // error={reference.referredByFirstName && !isValidAlphabet(reference.referredByFirstName)}
                              error={!!(reference.referredByFirstName && !isValidAlphabet(reference.referredByFirstName))}

                            />
                          </div>
                          <div>
                            <TextField
                              label="Last Name"
                              variant="outlined"
                              style={{ width: "250px", borderColor: reference.referredByLastName && !isValidAlphabet(reference.referredByLastName) ? 'red' : undefined }}
                              fullWidth
                              value={reference.referredByLastName}
                              onChange={(e) => handleReferenceChange(index, 'referredByLastName', e.target.value)}
                              error={!!(reference.referredByLastName && !isValidAlphabet(reference.referredByLastName))}
                            />
                          </div>
                          {isNewReferenceAdded && referenceList.length > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "5px" }}>
                              <MKAvatar src={deleteIcon} alt="sm" size="sm" onClick={() => handleDeleteReference(index)} />
                            </div>
                          )}
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <FormControl variant="outlined" style={{ width: '250px' }}>
                              <InputLabel id="ContactCountry">Contact Country</InputLabel>
                              <Select
                                labelId="contactCountry"
                                label="Contact Country"
                                fullWidth
                                onChange={(e) => handleReferenceContactCountryChange(index, 'referenceContactCountry', e.target.value)}
                                value={reference.referenceContactCountry}
                                style={{ minHeight: '44px' }}
                              >
                                {CountryList.getAll().map((country) => (
                                  <MenuItem key={country.name} value={country.name}>
                                    {country.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div>
                            <TextField
                              label="Reference Code"
                              name="Reference Code"
                              value={reference.referenceContactCountryCode}
                              InputProps={{
                                readOnly: true,
                              }}
                              style={{ width: '250px', minHeight: '44px' }}
                              fullWidth
                            />
                          </div>
                          <div>
                            <TextField
                              label="Mobile Number"
                              variant="outlined"
                              style={{
                                width: "250px",
                                borderColor: reference.referredByMobileNumber && !isNumeric(reference.referredByMobileNumber) ? 'red' : undefined
                              }}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (isNumeric(inputValue) || inputValue === "") {
                                  handleReferenceChange(index, 'referredByMobileNumber', inputValue);
                                }
                              }}
                              value={reference.referredByMobileNumber}
                              error={!!(reference.referredByMobileNumber && !isNumeric(reference.referredByMobileNumber))}
                              fullWidth
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <TextField
                              label="Email Id"
                              variant="outlined"
                              style={{
                                width: "250px",
                                borderColor: reference.referredByEmailID && !isValidEmail(reference.referredByEmailID) ? 'red' : undefined
                              }}
                              onChange={(e) => handleReferenceChange(index, 'referredByEmailID', e.target.value)}
                              value={reference.referredByEmailID}
                              error={!!(reference.referredByEmailID && !isValidEmail(reference.referredByEmailID))}
                              fullWidth
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddReference} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Reference</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginBottom: "10px" }}>
                      {referenceList.some(reference => Object.values(reference).some(value => value && value !== reference.trainerProfileID)) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleReferenceNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleReferenceSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleReferenceNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleReferenceSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 9 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Social Media</Typography>
                    <div>
                      <div style={{ display: 'flex' }}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Share your Social Media Url Informations</span> }]}
                          />
                        </Grid>
                      </div>
                      {socialMediaPlatforms.map((platform) => (
                        <div key={platform.name} style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <TextField
                              label={`${platform.label} Url`}
                              variant="outlined"
                              style={{ width: '520px' }}
                              fullWidth
                              value={socialMediaUrls[platform.name]}
                              onChange={(e) => handleSocialMediaUrlChange(platform.name, e.target.value)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginBottom: "10px" }}>
                      {Object.values(socialMediaUrls).some(value => value) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleSocialMediaNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleSocialMediaSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled onClick={handleSocialMediaNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleSocialMediaSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 2 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Skills</Typography>
                    <div>
                      <div style={{ display: 'flex' }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Share your skills</span> }]} />
                        </Grid>
                      </div>
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            margin: '20px 0',
                          }}
                        >
                          <Autocomplete
                            multiple
                            id="skills"
                            options={skillsName}
                            freeSolo
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Skill"
                                variant="standard"
                                style={{ marginTop: '10px', width: '700px' }}
                                fullWidth
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <SearchIcon fontSize="medium" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                            onChange={(e, value) => {
                              setSelectedSkills(value);
                              handleSkillsTextChange(e);
                              setSkillsText(value.join(', '));
                            }}
                          />
                          <Typography variant="caption" color="textSecondary" style={{ marginTop: '-10px' }}>
                            Select one or more technology by typing or choosing from the dropdown.
                          </Typography>
                        </div>
                        <TextField
                          multiline
                          rows={4}
                          fullWidth
                          variant="outlined"
                          label="Your Skills *"
                          value={skillsText}
                          // onChange={handleSkillsTextChange}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', marginTop: "20px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-40px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleSkillsNextClick} disabled={!skillsValid} >NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 10 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Work Sample</Typography>
                    <div>
                      {workSamples.map((workSample, index) => (
                        <div key={index}>
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <div>
                              <TextField
                                label="Title"
                                variant="outlined"
                                style={{ width: '250px' }}
                                fullWidth
                                value={workSample.title}
                                onChange={(e) => handleWorkSampleChange(index, 'title', e.target.value)}
                              />
                            </div>
                            {isNewWorkSampleAdded && workSamples.length > 1 && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: "5px" }}>
                                <MKAvatar src={deleteIcon} alt="sm" size="sm" onClick={() => handleDeleteWorkSample(index)} />
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <TextField
                                label="Description"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{ width: '520px' }}
                                fullWidth
                                value={workSample.description}
                                onChange={(e) => handleWorkSampleChange(index, 'description', e.target.value)}
                              />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                            <div>
                              <TextField
                                label="Work Sample URL (Eg. Github URL)"
                                variant="outlined"
                                style={{ width: '520px' }}
                                fullWidth
                                value={workSample.workUrl}
                                onChange={(e) => handleWorkSampleChange(index, 'workUrl', e.target.value)}
                              />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                              <MKTypography component="span" style={{ fontSize: '14px' }} variant="body2" fontWeight="regular" color="text">
                                Upload Document
                              </MKTypography>
                              <input
                                type="file"
                                id={`document-upload-${index}`}
                                accept="pdf/*"
                                style={{ display: 'none' }}
                                ref={documentFileInputRef}
                                onChange={handleDocumentUploadChange(index)}
                              />
                              <div style={{ display: 'flex', alignItems: 'center', marginLeft: "10px" }}>
                                <label htmlFor="document-upload">
                                  <MKButton onClick={handleDocumentUploadClick} variant="gradient" color="info" size="small">
                                    Upload
                                  </MKButton>
                                </label>
                                {documents[index].map((uploadedDocument, documentIndex) => (
                                  <div key={documentIndex} style={{ fontSize: '14px', marginLeft: '10px' }}>
                                    <span>{uploadedDocument.name}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                            {workSampleError && (
                              <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                {workSampleError}
                              </MKTypography>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddWorkSample} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Work Sample</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-45px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={onSubmitClick} disabled={!generalInfoValid && !personalInfoValid && !trainingExpInfoValid && workSampleError}>Submit</MKButton>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          </Container>
        </Card>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Page;